// Sport Energy Race-kit Bygger — motor + side-UI (Fase 4.26.0)
//
// FASE 4.26.0 (7. jul 2026): Ekstra produkt pr. depot. Ved siden af
// 'Skift produkt' kan atleten nu lægge et produkt OVEN I de globale
// på en enkelt strækning ('+ Tilføj ekstra her') med et antal-trin.
// Det tæller i kulhydrat- og natrium-dækningen (så en for stor ekstra
// gør baren rød over 120 %), i pakkelisten, i kurven og i delte links
// (ex-parametret). Motorens computePlan tager pr. ben et valgfrit
// L.extra: [{ c, na, qty, price, label, vid }] — default ingen, så
// alle eksisterende links og tests er uændrede.
//
// FASE 4.25.0 (7. jul 2026): Fire ting. (1) Standard-gel: vælger man
// TYPEN gels/chews/bar uden et konkret produkt, regner planen med en
// ren-energi standard (30/25/40 g, 0 mg natrium) — så gels bærer
// kulhydratet, og natrium ikke pustes op af en høj-natrium-drik der
// alene skal dække alt. (2) Dæknings-barer på kulhydrat OG væske i
// depot-cellerne (natrium havde den før). (3) Rød ved overdækning
// over 120 % (mere end 20 % over målet) på både total-rækkerne og
// celle-mini-barerne — lidt over er stadig grønt. (4) Toolbaren og
// Mine tal er væk fra race-kit-siden (data-no-toolbar); se-seg-pillen
// virker uændret. Motorens flaske-antal kommer FORTSAT kun fra
// svedraten — den opjusterer aldrig flasker for at nå kulhydrat.
//
// FASE 4.24.2 (7. jul 2026): Udsolgte produkter kan ikke vælges.
// Et helt-udsolgt produkt (Amacx Energy Drink) gav variant-id 0
// (selected_or_first_available_variant er nil ved udsolgt,
// snippettets default:0 gør det til 0), og et 0-id afviste HELE
// /cart/add.js-batchet — kurven endte tom med en fejl. Nu
// filtreres udsolgte + id-løse produkter helt væk fra alle
// dropdowns, og kurv-kaldet renser defensivt ethvert 0/tomt id.
//
// FASE 4.24.1 (6. jul 2026): Hele gels. Solids (gels, chews,
// barer) fordeles nu i HELE styk pr. strækning — man kan ikke
// tage en halv gel i et depot. Flasker og alle pr.-time-rater
// er urørte. Pakkeliste og kurv var allerede hele; nu stemmer
// stræknings-linjen og depot-kortene med dem.
//
// FASE 4.24.0 (6. jul 2026): Cykel. Sporten er nu et reelt valg
// (løb/cykel) — triatlon er taget ud af siden. Cykel får egne
// løbstyper (Landevejsløb / gran fondo og Tidsløb / rundeløb),
// eget kulhydrat-forslag (90 g/t — cyklens højere GI-tolerance,
// samme linje som træningsberegnerens FASE 7.23.0), km/t i stedet
// for min/km i planen, cykel-hm-regel (100 hm ≈ 2 km ekstra mod
// løbets 0,8) og sport-korrekt ordlyd på depot-kortene. Skabeloner
// filtreres pr. sport; delte links bærer sporten i sp-parametret,
// og gamle links uden sp læses som løb. Motorens computePlan tager
// cfg.sport ('run'/'bike') — default 'run', så alle eksisterende
// tests og links regner uændret.
//
// FASE 4.23.2 (jun 2026): Natrium-profilen kan nu også være 'lav'
// (screeningens tredje niveau) — forudvælger 450 mg/L-radioen.
//
// FASE 4.23.1 (jun 2026): Terminologi — 'ben' er ude af alt bruger-
// vendt sprog. Mellem to depoter hedder det en STRÆKNING, og rækken
// man tilføjer er et DEPOT (Phillips rettelse). Variabelnavne (legs)
// og den historiske FASE-log er uændrede; kun strenge og nyere
// kommentarer er rettet.
//
// FASE 4.23.0 (jun 2026): Depot-tidslinjen — plan-tabellen (7 kolonner,
// 12,5 px) er gentænkt som en lodret rute: skinne, noder pr. depot
// (prik / dropbag-pakke / mål-flag), ankomsten som det største tal og
// doserne som tre chips med dæknings-barer. Mørke og koffein-
// strækninger bærer måne/kop som tags. Samme data, samme pr. strækning/
// pr. time-toggle, samme skift-vælger pr. strækning — kun formen er
// ny. rowHtml er udgået.
//
// FASE 4.22.0 (jun 2026): Mikro-interaktioner — entré-animationen
// kører kun ved FØRSTE byg (ikke ved hvert visnings-skift), visnings-
// skiftet crossfader via View Transitions hvor det findes, koffein/
// nat/natrium-advarsler er ikon-noter i stedet for brødtekst,
// time-fliserne og velkomsten bærer ikon-sproget, kurv-knappen får
// mint succes-tilstand med haptik, og kopiér-link vender selv
// tilbage. Ren visning — motoren er fortsat urørt.
//
// FASE 4.21.0 (jun 2026): Resultatfladen løftet til trin-sprogets
// niveau — hero-metrikker (km/måltid/i mål/tempo) som store fliser
// øverst i BEGGE plan-typer, samlede dæknings-rækker (kulhydrat og
// natrium, ramt mod mål, med bar og procent), mini-barer i tabellens
// celler, linje-ikoner på foldene, og kurven som rolig liste i stedet
// for punktum-adskilt tekst. Ren visning — motoren er urørt.
//
// FASE 4.19.2 (11. jun 2026): KRITISK FIX — cartItems erklæres.
// Uerklæret tildeling virkede i løs tilstand men kastede
// ReferenceError i den minificerede live-fils strenge tilstand.
//
// FASE 4.19.1 (11. jun 2026): Robusthed — Byg-knappen bindes med
// addEventListener, calc læser felter og depoter direkte fra DOM
// (uafhængig af inline-handlers), og enhver undtagelse vises som
// synlig fejltekst i resultatfeltet.
//
// FASE 4.19.0 (11. jun 2026): Skabeloner — standard-fordelinger og
// kendte løb (Copenhagen Marathon) der fylder depotlisten med ét valg,
// og tolerant km-validering: afvigelse mod distancen nævnes roligt,
// men planen bygges altid.
//
// FASE 4.17.0 (11. jun 2026): Lav tærskel — kulhydrat-mål forud-
// fyldes pr. løbstype (uden at overskrive atletens egne tal),
// velkomst med tre trin i resultatfeltet, og 'Se et eksempel' der
// bygger et maraton på ét tryk.
//
// FASE 4.16.0 (11. jun 2026): Løbstype først (halv/maraton/ultra/
// tidsløb/backyard), depoter valgfrie — uden depoter får atleten
// en hurtig time-guide med produkt-rytme, koffein og nat-noter.
// Validering taler depot-navne, ikke 'ben 8'.
//
// FASE 4.15.0 (11. jun 2026): Natrium fra det faste tæller med,
// kapsler dækker resten EFTER drik og fast, per-ben produkt-override,
// ramt-vs-mål pr. ben, og total⇄pr. time-visning.
//
// FASE 4.14.0 (11. jun 2026): Produkt-TYPER med tilføj-knap (gels,
// chews, energibar deler rest-kulhydratet), kulhydrat-split vist pr.
// kilde, rød natrium-mangel med kapsel-opfordring, pakkeliste og
// depot-kort bag accordions, kapsel-filter rettet ('Kapsler' inde-
// holder ikke substringen 'kapsel').
//
// FASE 4.13.0 (11. jun 2026): Flaskens indhold i grupper (energi-,
// hydrerings-pulver, tabletter — natrium tæller på alt), elektrolyt-
// kapsler dækker rest-natrium, kurv-knap med totalpris (se-buy-
// sproget), og priser bæres i produktvalgene.
//
// FASE 4.11.0 (11. jun 2026): Korrekt per-portion-parsing (samme
// logik som rules — tallet efter skåstregen), natrium fra drik
// regnes med og vises, variant-id'er bæres i selects og URL
// (pid/did), og hele planen kan lægges i kurven.
//
// FASE 4.9.0 (11. jun 2026): Depot-kort — ét printbart klippekort pr.
// ben med afstand, hm, ca. tid, ankomst, pak-linje, time-rytme og
// nat/koffein-noter. Phillips lamineret-stak-i-lommen-metode.
// FASE 4.8.0: Natrium i tre niveauer (450/650/1000 mg/L), nat- og
// koffein-flag pr. ben, time-rytme (flasker og gels pr. time).
//
// FASE 4.6.0 (11. jun 2026): Koffein-vindue (2/3 af måltiden) og
// nat-sektion med pandelampe-tidspunkt og mørke ben.
// FASE 4.4.0: Valgfri hm-fordeling af tiden — måltiden er hellig,
// stigninger får blot en større andel af den.
//
// FASE 4.2.0 (11. jun 2026): Næringsmotor 2.0 — drik-mix kobles til
// væskeplanen i flaskesprog og tæller med i kulhydrat-dækningen;
// resten dækkes af det primære produkt. Depoter kan navngives, og
// afstande kan tastes som km-punkter (kumulativt, som løbssiderne
// angiver dem) eller som afstand fra forrige.
// FASE 4.1.0: komma-tolerant parsing i hele motoren (12,5 = 12.5),
// delt link med ugyldig depotliste falder tilbage til tom plan i
// stedet for at vælte siden, og mobil-visningen viser ALLE tal som
// stablede kort i stedet for en amputeret tabel.
// Motoren (computePlan, cumToLegs) er rene funktioner — testes i node.
// Sport: løb og cykel (FASE 4.24.0). Hm er valgfrit; på løb fordeler
// det tiden med 0,8 km pr. 100 hm, på cykel med 2 km pr. 100 hm.
// Profilen leverer målt svedtab automatisk.

(function () {
  'use strict';

  function num(v) {
    if (typeof v === 'number') return v;
    if (typeof v !== 'string' || v.trim() === '') return NaN;
    return parseFloat(v.replace(',', '.'));
  }
  function round50(x) { return Math.round(x / 50) * 50; }

  // FASE 4.11.0: Samme parser som rules-motoren — felterne er
  // 'pr. 100 g / pr. portion', og PORTIONEN står efter skåstregen.
  // Før blev første tal læst (pr. 100 g) — derfor stod Gel 100 til
  // 63 g i stedet for 25 g. Fundet ved Phillips Kullamannen-test.
  function perPortion(raw) {
    if (!raw || typeof raw !== 'string') return null;
    var m = raw.match(/\/\s*([\d.,]+)\s*(?:g|mg)/i);
    if (m) { var n = parseFloat(m[1].replace(',', '.')); return isNaN(n) ? null : n; }
    var s1 = raw.match(/([\d.,]+)\s*(?:g|mg)/i);
    if (s1) { var n2 = parseFloat(s1[1].replace(',', '.')); return isNaN(n2) ? null : n2; }
    return null;
  }

  // Km-punkter → afstande fra forrige. [23, 41, 60] → [23, 18, 19].
  function cumToLegs(points) {
    var out = [], prev = 0;
    for (var i = 0; i < points.length; i++) {
      var p = num(points[i]);
      if (isNaN(p) || p <= prev) {
        return { ok: false, error: 'Km-punkterne skal være stigende — punkt ' + (i + 1) + ' er ikke større end det forrige.' };
      }
      out.push(Math.round((p - prev) * 10) / 10);
      prev = p;
    }
    return { ok: true, legs: out };
  }

  // cfg: { startClock, goalMinutes, carbsPerHour, sweatMlPerHour,
  //   sodiumMgPerL, legs:[{name,km,hm,dropbag}], productCarbsG,
  //   drink:{carbsPerBottle, ratio} }  ratio: 1=alle flasker,
  //   0.5=hver anden, 0=ingen. Flaske = 500 ml (låst sprogbeslutning).
  function computePlan(cfg) {
    cfg = cfg || {};
    var legs = cfg.legs || [];
    if (!legs.length) return { ok: false, error: 'Tilføj mindst ét depot.' };
    var totalKm = 0;
    for (var i = 0; i < legs.length; i++) {
      var kmChk = num(legs[i].km);
      if (isNaN(kmChk) || kmChk <= 0 || kmChk > 500) {
        var ptNavn = legs[i].name || (i === legs.length - 1 ? 'Mål' : 'Depot ' + (i + 1));
        return { ok: false, error: 'Afstanden til ' + ptNavn + ' mangler eller er ugyldig — skriv km fra forrige punkt, eller ryd depotlisten for at få en hurtig time-guide.' };
      }
      totalKm += kmChk;
    }
    var goal = num(cfg.goalMinutes);
    if (isNaN(goal) || goal < 30 || goal > 4320) {
      return { ok: false, error: 'Måltiden skal være mellem 30 minutter og 72 timer.' };
    }
    var cph = num(cfg.carbsPerHour);
    if (isNaN(cph) || cph < 20 || cph > 130) {
      return { ok: false, error: 'Kulhydrat-målet skal være mellem 20 og 130 g i timen.' };
    }
    var sweat = num(cfg.sweatMlPerHour);
    if (isNaN(sweat) || sweat < 400 || sweat > 2500) {
      return { ok: false, error: 'Svedraten skal være mellem 400 og 2500 ml i timen.' };
    }
    // FASE 4.8.0: tre niveauer — lav ≈450, normal ≈650, høj ≈1000 mg/L.
    var naIn = num(cfg.sodiumMgPerL);
    var naPerL = naIn === 450 || naIn === 1000 ? naIn : 650;
    var startMin = parseClock(cfg.startClock);
    if (startMin === null) {
      return { ok: false, error: 'Starttiden skal skrives som tt:mm, fx 06:00.' };
    }
    // FASE 4.14.0: flere solid-produkter (gels/chews/bar) deler rest-
    // kulhydratet ligeligt. productCarbsG bevares som enkelt-produkt-
    // genvej (tests + gamle links).
    var solids = [];
    if (cfg.solids && cfg.solids.length) {
      for (var si = 0; si < cfg.solids.length && si < 3; si++) {
        var sc = num(cfg.solids[si].carbsG);
        // FASE 4.15.0: det faste bærer også natrium (näak-gel: 187 mg)
        if (!isNaN(sc) && sc >= 5) solids.push({ c: sc, na: num(cfg.solids[si].sodiumMg) > 0 ? num(cfg.solids[si].sodiumMg) : 0 });
      }
    } else {
      var prodCarbs = num(cfg.productCarbsG);
      if (!isNaN(prodCarbs) && prodCarbs >= 5) solids.push({ c: prodCarbs, na: 0 });
    }
    var hasProduct = solids.length > 0;
    // FASE 4.13.0: drik kan være ren elektrolyt (tabs, ~0 kulhydrat)
    // — kravet er nu kulhydrat ELLER natrium, ikke kulhydrat alene.
    var caps = cfg.caps && num(cfg.caps.sodiumPerCap) >= 50
      ? { na: num(cfg.caps.sodiumPerCap) } : null;
    var drink = cfg.drink && (num(cfg.drink.carbsPerBottle) >= 5 || num(cfg.drink.sodiumPerBottle) >= 50) && num(cfg.drink.ratio) > 0
      ? { c: num(cfg.drink.carbsPerBottle) >= 5 ? num(cfg.drink.carbsPerBottle) : 0, r: num(cfg.drink.ratio),
          na: num(cfg.drink.sodiumPerBottle) > 0 ? num(cfg.drink.sodiumPerBottle) : 0 } : null;

    // FASE 4.4.0: Valgfri hm-fordeling. Måltiden ændres ALDRIG —
    // stigninger får blot en større andel af den: 100 hm tæller som
    // ca. 0,8 km ekstra på løb (løbe-tommelfingerregel; nedløb
    // modelleres ikke). FASE 4.24.0: på cykel er reglen ca. 2 km pr.
    // 100 hm — stigninger koster relativt mere af en cykeltid end af
    // en løbetid. Uden hm-data på et ben bruges den rene afstand.
    var sport = cfg.sport === 'bike' ? 'bike' : 'run';
    var hmFactor = sport === 'bike' ? 2 : 0.8;
    var adjustHm = !!cfg.adjustHm;
    var effTotal = 0, effArr = [];
    for (i = 0; i < legs.length; i++) {
      var hmN = adjustHm ? (num(legs[i].hm) || 0) : 0;
      var eff = num(legs[i].km) + (hmN > 0 ? hmN / 100 * hmFactor : 0);
      effArr.push(eff); effTotal += eff;
    }
    var pace = goal / totalKm;          // vist gennemsnit (reelle km)
    var effPace = goal / effTotal;      // fordelingstempo (effektive km)
    var out = [], cum = startMin;
    var totC = 0, totF = 0, totU = 0, totDrRaw = 0, overCovered = false;
    for (i = 0; i < legs.length; i++) {
      var L = legs[i];
      var kmN = num(L.km);
      var minutes = effArr[i] * effPace, hours = minutes / 60;
      cum += minutes;
      var carbsG = Math.round(cph * hours);
      var fluidMl = round50(sweat * 0.75 * hours);
      var sodiumMg = Math.round(fluidMl / 1000 * naPerL / 10) * 10;
      var bottles = fluidMl / 500;
      var drinkCarbsG = drink ? Math.round(bottles * drink.r * drink.c) : 0;
      var drinkSodiumMg = drink && drink.na ? Math.round(bottles * drink.r * drink.na / 10) * 10 : 0;
      // Kapsler dækker det natrium, drikken ikke dækker.
      // Kapsler dækker det natrium, hverken drik eller det faste dækker.
      // (solidsNaMg beregnes først længere nede — flyttet i 4.15.0)
      var capsCount = null;
      if (drinkCarbsG > carbsG) overCovered = true;
      var gelCarbsG = Math.max(0, carbsG - drinkCarbsG);
      // FASE 4.15.0: per-ben produkt-override — atleter der vil justere
      // enkelte sektioner (større gel på lange ben, mindre på korte).
      var legSolids = L.override && num(L.override.carbsG) >= 5
        ? [{ c: num(L.override.carbsG), na: num(L.override.sodiumMg) > 0 ? num(L.override.sodiumMg) : 0 }]
        : solids;
      var legHas = legSolids.length > 0;
      var solidUnits = null, units = null, solidsNaMg = 0, solidsCarbsAct = 0;
      if (legHas) {
        solidUnits = [];
        var share = gelCarbsG / legSolids.length;
        for (var sj = 0; sj < legSolids.length; sj++) {
          // FASE 4.24.1: hele styk — en gel/chew/bar er diskret. Man kan
          // ikke tage en halv gel i et depot, så vi runder op til hele.
          // Rater (pr. time) regnes stadig ud fra dette hele tal.
          var u = Math.ceil(share / legSolids[sj].c);
          solidUnits.push(u);
          solidsNaMg += u * legSolids[sj].na;
          solidsCarbsAct += u * legSolids[sj].c;
        }
        solidsNaMg = Math.round(solidsNaMg / 10) * 10;
        units = legSolids.length === 1 ? solidUnits[0]
          : solidUnits.reduce(function (a, b) { return a + b; }, 0);
      }
      // FASE 4.26.0: ekstra produkt(er) pr. depot — fast antal, oven i
      // det auto-fordelte. Tæller i kulhydrat- og natrium-dækningen, så
      // en for stor ekstra korrekt får baren til at gå over 120 % (rød).
      var extras = [];
      if (L.extra && L.extra.length) {
        for (var xi = 0; xi < L.extra.length; xi++) {
          var ex = L.extra[xi];
          var exQ = Math.max(1, Math.round(num(ex.qty) || 1));
          var exC = num(ex.c) || 0, exNa = num(ex.na) || 0;
          if (exC < 1 && exNa < 1) continue;
          extras.push({ qty: exQ, c: exC, na: exNa, vid: ex.vid || '', price: num(ex.price) || 0, label: ex.label || 'Ekstra' });
          solidsCarbsAct += exQ * exC;
          solidsNaMg += exQ * exNa;
        }
        solidsNaMg = Math.round(solidsNaMg / 10) * 10;
      }
      if (caps) capsCount = Math.ceil(Math.max(0, sodiumMg - drinkSodiumMg - solidsNaMg) / caps.na);
      // Pr. strækning er antallet nu hele styk (FASE 4.24.1), så
      // pakkelistens segment-sum er allerede hele tal — ceil er en
      // billig sikkerhed mod flydende-komma-støj.
      var cumStart = cum - minutes;
      var drinkRaw = drink ? bottles * drink.r : 0;
      var drinkPortions = drink ? Math.ceil(drinkRaw) : 0;
      totC += carbsG; totF += fluidMl;
      if (units && solids.length === 1) totU += units; totDrRaw += drinkRaw;
      out.push({
        name: L.name || (i === legs.length - 1 ? 'Mål' : 'Depot ' + (i + 1)),
        km: kmN, hm: L.hm || null, dropbag: !!L.dropbag,
        minutes: Math.round(minutes), clock: fmtClock(cum),
        carbsG: carbsG, fluidMl: fluidMl, sodiumMg: sodiumMg,
        drinkCarbsG: drinkCarbsG, gelCarbsG: gelCarbsG, drinkSodiumMg: drinkSodiumMg,
        units: units, solidUnits: solidUnits, drinkPortions: drinkPortions, drinkRaw: drinkRaw, caps: capsCount,
        overridden: !!(L.override && num(L.override.carbsG) >= 5),
        extras: extras,
        solidsNaMg: solidsNaMg,
        achievedCarbsG: Math.round(drinkCarbsG + solidsCarbsAct),
        achievedNaMg: Math.round((drinkSodiumMg + solidsNaMg + (capsCount ? capsCount * caps.na : 0)) / 10) * 10,
        naShortMg: Math.max(0, sodiumMg - drinkSodiumMg - solidsNaMg - (capsCount ? capsCount * caps.na : 0)),
        // FASE 4.8.0: flag og rytme til depot-kortene
        nightLeg: legIsNight(cumStart, cum),
        caffeineLeg: !!cfg.caffeine && cum > goal * 2 / 3 + startMin,
        bottles: Math.round(bottles * 2) / 2,
        bottlesPerHour: Math.round(bottles / hours * 2) / 2,
        unitsPerHour: units !== null && hours > 0 ? Math.round(units / hours * 2) / 2 : null,
        durationLabel: fmtDur(minutes)
      });
    }

    var packing = [], segC = 0, segU = [], segD = 0, segK = 0, from = 'start';
    // segD akkumulerer RÅ flaske-portioner og ceiles ved segment-luk.
    for (i = 0; i < out.length; i++) {
      segC += out[i].carbsG;
      if (out[i].solidUnits) {
        for (var su = 0; su < out[i].solidUnits.length; su++) {
          segU[su] = (segU[su] || 0) + out[i].solidUnits[su];
        }
      }
      segD += out[i].drinkRaw;
      if (out[i].caps) segK += out[i].caps;
      var last = i === out.length - 1;
      if (out[i].dropbag || last) {
        packing.push({
          from: from, to: last ? 'mål' : out[i].name + ' (dropbag)',
          carbsG: segC,
          units: hasProduct && solids.length === 1 ? segU[0] : null,
          solidUnits: hasProduct ? segU.slice() : null,
          drinkPortions: drink ? Math.ceil(segD - 1e-9) : null,
          caps: caps ? segK : null
        });
        from = out[i].name; segC = 0; segU = []; segD = 0; segK = 0;
      }
    }

    // FASE 4.6.0: Koffein-vinduet åbner ved 2/3 af måltiden — samme
    // princip som guidens race-plan. Nat: ben med ankomst mellem
    // 21 og 06 markeres, og pandelampe-tidspunktet er første møde
    // med mørket (eller fra start, hvis løbet starter i nat-vinduet).
    var caffeine = null;
    if (cfg.caffeine) {
      var thr = goal * 2 / 3, acc = 0, atLeg = out[out.length - 1].name;
      for (i = 0; i < out.length; i++) {
        acc += out[i].minutes;
        if (acc >= thr) { atLeg = out[i].name; break; }
      }
      caffeine = { clock: fmtClock(startMin + thr), beforeLeg: atLeg };
    }
    function isNight(min) { var h = Math.floor((min % 1440) / 60); return h >= 21 || h < 6; }
    var night = null, nightNames = [], cum2 = startMin;
    var headlampFrom = isNight(startMin) ? 'fra start' : null;
    for (i = 0; i < out.length; i++) {
      cum2 += out[i].minutes;
      if (isNight(cum2)) {
        nightNames.push(out[i].name);
        if (!headlampFrom) headlampFrom = 'ca. kl. 21:00, før ' + out[i].name;
      }
    }
    if (nightNames.length) night = { legs: nightNames, headlampFrom: headlampFrom };

    return {
      ok: true, totalKm: Math.round(totalKm * 10) / 10,
      sport: sport,
      drinkRatio: drink ? drink.r : null,
      hmAdjusted: adjustHm && effTotal > totalKm,
      caffeine: caffeine, night: night,
      paceMinPerKm: Math.round(pace * 100) / 100,
      legs: out, packing: packing, overCovered: overCovered,
      sodiumShort: out.some(function (L) { return L.naShortMg >= 100; }),
      totals: { carbsG: totC, fluidMl: totF,
        caps: caps ? out.reduce(function (a, L) { return a + (L.caps || 0); }, 0) : null,
        solidUnits: hasProduct ? solids.map(function (_, ix) {
          return Math.ceil(out.reduce(function (a, L) { return a + (L.solidUnits ? L.solidUnits[ix] : 0); }, 0));
        }) : null,
        units: hasProduct && solids.length === 1 ? totU : null, drinkPortions: drink ? Math.ceil(totDrRaw - 1e-9) : null }
    };
  }

  function legIsNight(fromMin, toMin) {
    // Ben i mørke: starter eller slutter mellem 21 og 06, eller
    // spænder hen over nat-vinduet (lange ultra-ben).
    function isN(m) { var h = Math.floor((m % 1440) / 60); return h >= 21 || h < 6; }
    if (isN(fromMin) || isN(toMin)) return true;
    return toMin - fromMin >= 540; // 9+ timer rammer altid mørke
  }

  function fmtDur(min) {
    var h = Math.floor(min / 60), m = Math.round(min) % 60;
    return h > 0 ? h + ' t ' + (m < 10 ? '0' : '') + m + ' min' : m + ' min';
  }

  function parseClock(s) {
    if (typeof s !== 'string') return null;
    var m = s.trim().match(/^(\d{1,2})[:.](\d{2})$/);
    if (!m) return null;
    var h = parseInt(m[1], 10), mi = parseInt(m[2], 10);
    if (h > 23 || mi > 59) return null;
    return h * 60 + mi;
  }
  function fmtClock(totalMin) {
    var days = Math.floor(totalMin / 1440);
    var m = Math.round(totalMin) % 1440;
    var h = Math.floor(m / 60), mi = m % 60;
    var s = (h < 10 ? '0' : '') + h + ':' + (mi < 10 ? '0' : '') + mi;
    return days > 0 ? s + ' (+' + days + ' dag)' : s;
  }

  window.SportEnergyRaceKit = { computePlan: computePlan, cumToLegs: cumToLegs, parseClock: parseClock };

  // ── Side-UI ────────────────────────────
  if (typeof document === 'undefined') return;

  function $(id) { return document.getElementById(id); }
  var legsState = [];
  function defaultLegs() { return [{ name: '', km: '', hm: '', dropbag: false }, { name: '', km: '', hm: '', dropbag: false }]; }
  function cumMode() { var el = $('rk-cum'); return !!(el && el.checked); }

  // FASE 4.14.0: Atleten vælger produkt-TYPER (tilføj-knap) og så
  // konkrete produkter i hver kategori. Flaskerne og kapslerne har
  // egne grupper; denne vælger dækker det faste: gels, chews, barer.
  // FASE 4.16.0: Løbstype først — depoter er valgfrie. Uden depoter
  // får atleten en hurtig time-guide i stedet for en depot-plan.
  var RACE_TYPES_RUN = [
    { key: 'halv', label: 'Halvmaraton', km: 21.1 },
    { key: 'maraton', label: 'Maraton', km: 42.2 },
    { key: 'ultra', label: 'Ultraløb', km: null },
    { key: 'runde', label: 'Tidsløb / rundeløb', km: null },
    { key: 'backyard', label: 'Backyard ultra', km: null }
  ];
  // FASE 4.24.0: Cyklens løbstyper. Distance-typen dækker alt fra
  // motionsløb til brevet (måltid op til 72 timer); runde-typen
  // dækker 6/12/24-timers og tidsløb. Egne nøgler (cdist/crunde),
  // så delte links aldrig kan forveksle sport.
  var RACE_TYPES_BIKE = [
    { key: 'cdist', label: 'Landevejsløb / gran fondo', km: null },
    { key: 'crunde', label: 'Tidsløb / rundeløb', km: null }
  ];
  function raceTypes() { return sport === 'bike' ? RACE_TYPES_BIKE : RACE_TYPES_RUN; }
  var BACKYARD_KM = 6.7; // fast rundelængde, 1 time pr. runde
  var sport = 'run';
  var raceType = 'ultra';
  // FASE 4.17.0: kulhydrat-målet forudfyldes efter løbstype — men
  // kun hvis feltet er tomt eller stadig står på vores eget forslag.
  // Atletens egne tal overskrives aldrig.
  // Cykel-forslagene ligger et hak over løb — samme faglige linje som
  // træningsberegnerens cykel-løft (bedre indtags-mulighed, højere
  // GI-tolerance på cyklen).
  var CARB_DEFAULTS = { halv: 60, maraton: 75, ultra: 90, runde: 75, backyard: 75, cdist: 90, crunde: 90 };
  var lastAutoCarbs = null;
  function autoCarbs() {
    var el = $('rk-carbs');
    if (!el) return;
    var cur = el.value.trim();
    if (cur === '' || cur === String(lastAutoCarbs)) {
      lastAutoCarbs = CARB_DEFAULTS[raceType] || 80;
      el.value = String(lastAutoCarbs);
    }
  }

  function renderRaceFields() {
    var pills = $('rk-race-type');
    var box = $('rk-race-fields');
    if (!pills || !box) return;
    var ph = '';
    var RTS = raceTypes();
    for (var i = 0; i < RTS.length; i++) {
      var rt = RTS[i];
      ph += '<label class="seg-opt"><input type="radio" name="rk-rt" value="' + rt.key + '"' + (raceType === rt.key ? ' checked' : '') + ' onchange="RK.raceType(this.value)"><span>' + rt.label + '</span></label>';
    }
    pills.innerHTML = ph;
    var f = '<div class="sv-grid"><label class="sv-field"><span class="sv-label">Starttid</span>'
      + '<input type="text" inputmode="numeric" id="rk-start" placeholder="fx 06:00" value="' + escA(raceVals.start) + '" autocomplete="off" onchange="RK.raceVal(\'start\',this.value)"></label>';
    if (raceType === 'backyard') {
      f += '<label class="sv-field"><span class="sv-label">Forventede runder</span>'
        + '<input type="text" inputmode="numeric" id="rk-rounds" placeholder="fx 24" value="' + escA(raceVals.rounds) + '" autocomplete="off" onchange="RK.raceVal(\'rounds\',this.value)"></label></div>'
        + '<p class="sv-foot" style="margin-top:6px">Hver runde er 6,7 km og starter på hel time — indtag i paddocken.</p>';
    } else if (raceType === 'runde' || raceType === 'crunde') {
      f += '<label class="sv-field"><span class="sv-label">Varighed (timer)</span>'
        + '<input type="text" inputmode="numeric" id="rk-hours" placeholder="fx 12" value="' + escA(raceVals.hours) + '" autocomplete="off" onchange="RK.raceVal(\'hours\',this.value)"></label>'
      + '<label class="sv-field"><span class="sv-label">Forventet distance (km)</span>'
        + '<input type="text" inputmode="decimal" id="rk-km" placeholder="fx 100" value="' + escA(raceVals.km) + '" autocomplete="off" onchange="RK.raceVal(\'km\',this.value)"></label></div>'
        + '<p class="sv-foot" style="margin-top:6px">Indtag ved hver runde-passage — time-guiden fortæller hvad.</p>';
    } else {
      var ghPh = raceType === 'halv' ? 'fx 1' : raceType === 'maraton' ? 'fx 4' : raceType === 'cdist' ? 'fx 5' : 'fx 24';
      f += '<label class="sv-field"><span class="sv-label">Måltid</span>'
        + '<span class="rk-goal"><input type="text" inputmode="numeric" id="rk-goal-h" placeholder="' + ghPh + '" value="' + escA(raceVals.gh) + '" autocomplete="off" onchange="RK.raceVal(\'gh\',this.value)"><span>t</span>'
        + '<input type="text" inputmode="numeric" id="rk-goal-m" placeholder="min" value="' + escA(raceVals.gm) + '" autocomplete="off" onchange="RK.raceVal(\'gm\',this.value)"><span>min</span></span></label>';
      if (raceType === 'ultra' || raceType === 'cdist') {
        f += '<label class="sv-field"><span class="sv-label">Distance (km)</span>'
          + '<input type="text" inputmode="decimal" id="rk-km" placeholder="' + (raceType === 'cdist' ? 'fx 160' : 'fx 100') + '" value="' + escA(raceVals.km) + '" autocomplete="off" onchange="RK.raceVal(\'km\',this.value)"></label>'
        + '<label class="sv-field"><span class="sv-label">Højdemeter (valgfrit)</span>'
          + '<input type="text" inputmode="numeric" id="rk-hm-total" placeholder="' + (raceType === 'cdist' ? 'fx 2500' : 'fx 3500') + '" value="' + escA(raceVals.hm) + '" autocomplete="off" onchange="RK.raceVal(\'hm\',this.value)"></label>';
      }
      f += '</div>';
    }
    box.innerHTML = f;
    // Depoter er kun relevante med faste depoter på ruten
    var depotCard = $('rk-depot-card');
    if (depotCard) depotCard.style.display = (raceType === 'runde' || raceType === 'crunde' || raceType === 'backyard') ? 'none' : '';
    // FASE 4.24.0: rækken er lige genbygget — den glidende se-seg-pille
    // skal have nye lyttere og nyt felt-antal (toolbar.js's observer
    // dækker kun de første sekunder efter load).
    if (window.SEGTB && window.SEGTB.initSegPills) window.SEGTB.initSegPills();
  }

  var raceVals = { start: '06:00', gh: '', gm: '', km: '', hm: '', hours: '', rounds: '' };
  // FASE 4.24.0: sporten styrer løbstyperne, kulhydrat-forslaget og
  // skabelon-listen. Er den valgte type ikke gyldig i den nye sport,
  // vælges sportens standard (løb: ultra, cykel: landevejsløb).
  function setSport(v) {
    sport = v === 'bike' ? 'bike' : 'run';
    var ok = false, RTS = raceTypes();
    for (var i = 0; i < RTS.length; i++) if (RTS[i].key === raceType) { ok = true; break; }
    if (!ok) raceType = sport === 'bike' ? 'cdist' : 'ultra';
    renderRaceFields();
    autoCarbs();
    fillTemplates();
  }
  function setRaceType(t) { raceType = t; renderRaceFields(); autoCarbs(); }
  function setRaceVal(k, v) { raceVals[k] = v; }

  // Race-rammer ud fra typen: totalKm + goalMinutes (null = depot-styret)
  // FASE 4.19.1: calc stoler på felterne, ikke på onchange-cacher —
  // så virker Byg, selv hvis sidens inline-handlers er blokeret.
  function fieldVal(id, fallback) {
    var el = $(id);
    return el && String(el.value).trim() !== '' ? el.value : fallback;
  }
  function raceFrame() {
    raceVals.km = fieldVal('rk-km', raceVals.km);
    raceVals.hm = fieldVal('rk-hm-total', raceVals.hm);
    raceVals.hours = fieldVal('rk-hours', raceVals.hours);
    raceVals.rounds = fieldVal('rk-rounds', raceVals.rounds);
    raceVals.start = fieldVal('rk-start', raceVals.start);
    if (raceType === 'halv') return { km: 21.1, goal: goalMinutes() };
    if (raceType === 'maraton') return { km: 42.2, goal: goalMinutes() };
    if (raceType === 'ultra') return { km: num(raceVals.km), goal: goalMinutes() };
    if (raceType === 'cdist') return { km: num(raceVals.km), goal: goalMinutes() };
    if (raceType === 'runde' || raceType === 'crunde') return { km: num(raceVals.km), goal: (num(raceVals.hours) || 0) * 60 };
    if (raceType === 'backyard') {
      var rds = Math.round(num(raceVals.rounds) || 0);
      return { km: Math.round(rds * BACKYARD_KM * 10) / 10, goal: rds * 60 };
    }
    return { km: null, goal: goalMinutes() };
  }

  // FASE 4.19.0: Skabeloner — standard-fordelinger pr. løbstype og
  // kendte løb med deres faktiske forplejningszoner. Punkterne er
  // km-punkter (kumulative), så de matcher løbets egen depotliste.
  var TEMPLATES = [
    { key: 'cph-maraton', group: 'Kendte løb', label: 'Copenhagen Marathon — forplejningszoner', raceType: 'maraton', legs: [
      { name: 'Drikkezone', km: '3,8' }, { name: 'Drik + banan', km: '8,1' }, { name: 'Drikkezone', km: '12,3' },
      { name: 'Drik + High5-gel', km: '16' }, { name: 'Drikkezone', km: '19,8' }, { name: 'Faxe Kondi-zone', km: '21,1' },
      { name: 'Drik + banan', km: '24,3' }, { name: 'Drik + High5-gel', km: '27,8' }, { name: 'Drikkezone', km: '32,7' },
      { name: 'Faxe Booster-zone', km: '35,3' }, { name: 'Drik + banan', km: '35,7' }, { name: 'Drikkezone', km: '38,3' },
      { name: 'Mål', km: '42,2' } ] },
    { key: 'std-halv', group: 'Standard-fordeling', label: 'Halvmaraton — depot hver 5. km', raceType: 'halv', legs: [
      { name: '', km: '5' }, { name: '', km: '10' }, { name: '', km: '15' }, { name: 'Mål', km: '21,1' } ] },
    { key: 'std-maraton', group: 'Standard-fordeling', label: 'Maraton — depot hver 5. km', raceType: 'maraton', legs: [
      { name: '', km: '5' }, { name: '', km: '10' }, { name: '', km: '15' }, { name: '', km: '20' },
      { name: '', km: '25' }, { name: '', km: '30' }, { name: '', km: '35' }, { name: 'Mål', km: '42,2' } ] },
    { key: 'std-ultra50', group: 'Standard-fordeling', label: 'Ultra 50 km — depot hver 10. km', raceType: 'ultra', km: '50', legs: [
      { name: '', km: '10' }, { name: '', km: '20' }, { name: '', km: '30' }, { name: '', km: '40' }, { name: 'Mål', km: '50' } ] },
    { key: 'std-ultra100', group: 'Standard-fordeling', label: 'Ultra 100 km — depot ca. hver 15. km', raceType: 'ultra', km: '100', legs: [
      { name: '', km: '15' }, { name: '', km: '30' }, { name: '', km: '45', dropbag: true }, { name: '', km: '60' },
      { name: '', km: '75', dropbag: true }, { name: '', km: '90' }, { name: 'Mål', km: '100' } ] },
    // FASE 4.24.0: cykel-standard. Kendte cykelløb kommer på, når
    // Phillip leverer depotlisterne — vi gætter ikke forplejningszoner.
    { key: 'std-cykel160', group: 'Standard-fordeling', sport: 'bike', raceType: 'cdist', km: '160',
      label: 'Landevejsløb 160 km — depot ca. hver 40. km', legs: [
      { name: '', km: '40' }, { name: '', km: '80' }, { name: '', km: '120' }, { name: 'Mål', km: '160' } ] }
  ];
  function fillTemplates() {
    var sel = $('rk-tmpl');
    if (!sel) return;
    var groups = {}, order = [];
    for (var i = 0; i < TEMPLATES.length; i++) {
      // Skabeloner uden sport-felt er løb (alle de historiske).
      if ((TEMPLATES[i].sport || 'run') !== sport) continue;
      var g = TEMPLATES[i].group;
      if (!groups[g]) { groups[g] = []; order.push(g); }
      groups[g].push(TEMPLATES[i]);
    }
    var html = '<option value="">Byg selv — eller hent en skabelon</option>';
    for (var go = 0; go < order.length; go++) {
      html += '<optgroup label="' + order[go] + '">';
      for (var k = 0; k < groups[order[go]].length; k++) {
        html += '<option value="' + groups[order[go]][k].key + '">' + groups[order[go]][k].label + '</option>';
      }
      html += '</optgroup>';
    }
    sel.innerHTML = html;
  }
  function applyTemplate(key) {
    var t = null;
    for (var i = 0; i < TEMPLATES.length; i++) if (TEMPLATES[i].key === key) { t = TEMPLATES[i]; break; }
    if (!t) return;
    raceType = t.raceType;
    if (t.km) raceVals.km = t.km;
    renderRaceFields();
    autoCarbs();
    if ($('rk-cum')) $('rk-cum').checked = true;
    legsState = t.legs.map(function (L) { return { name: L.name || '', km: L.km, hm: '', dropbag: !!L.dropbag }; });
    renderLegs();
  }

  var SOLID_CATS = [
    { key: 'gels', label: 'Gels', test: function (p) { return /gel/i.test(p.v); } },
    { key: 'chews', label: 'Chews', test: function (p) { return /chew|crew/i.test(p.v); } },
    { key: 'bar', label: 'Energibar', test: function (p) { return /bar/i.test(p.v) && !/barer\s*&/i.test(p.v); } }
  ];
  var solidsState = [{ cat: 'gels', vid: '' }];

  function renderSolids() {
    var box = $('rk-solids');
    if (!box) return;
    var html = '';
    for (var i = 0; i < solidsState.length; i++) {
      var row = solidsState[i];
      var catSel = '<select class="rk-select" aria-label="Kategori" onchange="RK.solidCat(' + i + ',this.value)">';
      for (var c = 0; c < SOLID_CATS.length; c++) {
        catSel += '<option value="' + SOLID_CATS[c].key + '"' + (row.cat === SOLID_CATS[c].key ? ' selected' : '') + '>' + SOLID_CATS[c].label + '</option>';
      }
      catSel += '</select>';
      var cat = SOLID_CATS.filter(function (x) { return x.key === row.cat; })[0] || SOLID_CATS[0];
      var items = productList(function (p) { return cat.test(p); }, 10);
      var prodSel = '<select class="rk-select" id="rk-solid-' + i + '" aria-label="Produkt" onchange="RK.solidVid(' + i + ',this.value)">'
        + '<option value="">Vælg ' + cat.label.toLowerCase() + '</option>';
      for (var k = 0; k < items.length; k++) {
        prodSel += '<option value="' + items[k].vid + '" data-c="' + items[k].carbsG + '" data-na="' + items[k].sodiumMg + '" data-price="' + items[k].priceKr + '"' + (String(row.vid) === String(items[k].vid) ? ' selected' : '') + '>' + items[k].label + '</option>';
      }
      prodSel += '</select>';
      html += '<div class="rk-solid-row">' + catSel + prodSel
        + (solidsState.length > 1 ? '<button type="button" class="rk-leg-x" aria-label="Fjern produkt" onclick="RK.solidRemove(' + i + ')">×</button>' : '<span class="rk-leg-x"></span>')
        + '</div>';
    }
    box.innerHTML = html;
  }

  function solidCat(i, v) { if (solidsState[i]) { solidsState[i].cat = v; solidsState[i].vid = ''; renderSolids(); } }
  function solidVid(i, v) { if (solidsState[i]) solidsState[i].vid = v; }
  function solidAdd() { if (solidsState.length < 3) { solidsState.push({ cat: 'gels', vid: '' }); renderSolids(); } }
  function solidRemove(i) { solidsState.splice(i, 1); renderSolids(); }

  // FASE 4.25.0: standard-produkt pr. kategori når atleten har valgt en
  // TYPE men ikke et konkret produkt. Ren energi (0 mg natrium), så
  // gels bærer kulhydratet uden at puste natrium op. vid:'' = tæller i
  // planen, men lægges ikke i kurven (kurv-byggeren springer tomme over).
  var SOLID_DEFAULTS = {
    gels: { carbsG: 30, label: 'Gel (standard, 30 g)' },
    chews: { carbsG: 25, label: 'Chews (standard, 25 g)' },
    bar: { carbsG: 40, label: 'Energibar (standard, 40 g)' }
  };
  function solidsCfg() {
    var out = [];
    for (var i = 0; i < solidsState.length; i++) {
      var sel = $('rk-solid-' + i);
      if (!sel) continue;
      if (sel.selectedIndex <= 0) {
        // Type valgt, produkt ikke valgt → standard-gel for kategorien.
        var cat = solidsState[i] ? solidsState[i].cat : 'gels';
        var def = SOLID_DEFAULTS[cat] || SOLID_DEFAULTS.gels;
        out.push({ carbsG: def.carbsG, sodiumMg: 0, vid: '', priceKr: 0, label: def.label, isDefault: true });
        continue;
      }
      var o = sel.options[sel.selectedIndex];
      out.push({ carbsG: num(o.getAttribute('data-c')), sodiumMg: num(o.getAttribute('data-na')) || 0, vid: o.value,
        priceKr: num(o.getAttribute('data-price')) || 0,
        label: o.text.replace(/ \([^)]*\)$/, '') });
    }
    return out;
  }

  function capsCfg() {
    var d = selData('rk-caps');
    return d && d.sodiumMg >= 50 ? { sodiumPerCap: d.sodiumMg } : null;
  }

  function productList(test, minC) {
    var d = window.SportEnergyGuideData;
    if (!d || !d.products) return [];
    var out = [];
    for (var i = 0; i < d.products.length; i++) {
      var p = d.products[i];
      var c = perPortion(String(p.kulhydrater_raw || '')) || 0;
      var na = perPortion(String(p.natrium_raw || '')) || 0;
      var v = String(p.variant_raw || p.variant || p.type_raw || '');
      var hyd = !!p.is_hydration_product;
      if (!test({ v: v, c: c, na: na, hyd: hyd })) continue;
      if (c < minC && na < 50) continue;
      // FASE 4.24.2: udsolgte produkter (og produkter uden gyldig
      // købs-variant) må ikke kunne vælges. selected_or_first_available
      // _variant er nil ved helt-udsolgt, og snippettets default:0 giver
      // id 0 — et 0-id afviser hele /cart/add.js-batchet. Vi filtrerer
      // dem væk, så atleten ikke planlægger om et produkt, der ikke kan
      // købes.
      var vid0 = p.default_variant_id;
      if (p.available === false || !vid0 || String(vid0) === '0') continue;
      out.push({
        label: (p.brand_raw || p.brand ? (p.brand_raw || p.brand) + ' ' : '') + (p.name || p.title)
          + ' (' + (c >= 5 ? Math.round(c) + ' g' : Math.round(na) + ' mg natrium') + ')',
        carbsG: c,
        sodiumMg: na,
        priceKr: parseFloat(String(p.price_kr || '').replace(',', '.')) || 0,
        vid: p.default_variant_id || ''
      });
    }
    out.sort(function (a, b) { return a.label < b.label ? -1 : 1; });
    return out;
  }

  function fillSelect(id, items, empty) {
    var sel = $(id);
    if (!sel) return;
    var html = '<option value="">' + empty + '</option>';
    for (var i = 0; i < items.length; i++) {
      html += '<option value="' + items[i].vid + '" data-c="' + items[i].carbsG + '" data-na="' + items[i].sodiumMg + '" data-price="' + items[i].priceKr + '">' + items[i].label + '</option>';
    }
    sel.innerHTML = html;
  }

  function selData(id) {
    var sel = $(id);
    if (!sel || sel.selectedIndex <= 0) return null;
    var o = sel.options[sel.selectedIndex];
    return { vid: o.value, carbsG: num(o.getAttribute('data-c')), sodiumMg: num(o.getAttribute('data-na')) || 0, priceKr: num(o.getAttribute('data-price')) || 0 };
  }

  function fillGroupedDrink() {
    var sel = $('rk-drink');
    if (!sel) return;
    function opts(items) {
      var h = '';
      for (var i = 0; i < items.length; i++) {
        h += '<option value="' + items[i].vid + '" data-c="' + items[i].carbsG + '" data-na="' + items[i].sodiumMg + '" data-price="' + items[i].priceKr + '">' + items[i].label + '</option>';
      }
      return h;
    }
    var energi = productList(function (p) { return /pulver|mix|drik/i.test(p.v) && !p.hyd && !/tablet|kapsel/i.test(p.v); }, 20);
    var hydr = productList(function (p) { return p.hyd && !/tablet|kapsel/i.test(p.v) && /pulver|mix|drik/i.test(p.v); }, 0);
    var tabs = productList(function (p) { return /tablet/i.test(p.v); }, 0);
    var html = '<option value="">Kun vand</option>';
    if (energi.length) html += '<optgroup label="Energipulver">' + opts(energi) + '</optgroup>';
    if (hydr.length) html += '<optgroup label="Hydrering">' + opts(hydr) + '</optgroup>';
    if (tabs.length) html += '<optgroup label="Elektrolyt-tabletter">' + opts(tabs) + '</optgroup>';
    sel.innerHTML = html;
  }

  function renderLegs() {
    var box = $('rk-legs');
    if (!box) return;
    var cum = cumMode();
    var html = '';
    for (var i = 0; i < legsState.length; i++) {
      var L = legsState[i];
      var isGoal = i === legsState.length - 1;
      html += '<div class="rk-leg">'
        + '<input type="text" class="rk-leg-namein" value="' + escA(L.name) + '" placeholder="' + (isGoal ? 'Mål' : 'Depot ' + (i + 1)) + '" aria-label="Navn på punkt ' + (i + 1) + '" onchange="RK.setLeg(' + i + ',\'name\',this.value)">'
        + '<input type="text" inputmode="decimal" value="' + escA(L.km) + '" placeholder="' + (cum ? 'ved km' : 'km fra forrige') + '" aria-label="Kilometer, punkt ' + (i + 1) + '" onchange="RK.setLeg(' + i + ',\'km\',this.value)">'
        + '<input type="text" inputmode="numeric" value="' + escA(L.hm) + '" placeholder="hm (valgfrit)" aria-label="Højdemeter, punkt ' + (i + 1) + '" onchange="RK.setLeg(' + i + ',\'hm\',this.value)">'
        + (isGoal ? '<span class="rk-leg-drop"></span>'
            : '<label class="rk-leg-drop"><input type="checkbox"' + (L.dropbag ? ' checked' : '') + ' onchange="RK.setLeg(' + i + ',\'dropbag\',this.checked)"><span class="rk-dropbox" aria-hidden="true"></span>Dropbag</label>')
        + (isGoal || legsState.length <= 2 ? '<span class="rk-leg-x"></span>'
            : '<button type="button" class="rk-leg-x" aria-label="Fjern punkt ' + (i + 1) + '" onclick="RK.removeLeg(' + i + ')">×</button>')
        + '</div>';
    }
    box.innerHTML = html;
  }
  function escA(v) { return String(v == null ? '' : v).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }

  function setLeg(i, k, v) { if (legsState[i]) legsState[i][k] = v; }
  function addLeg() { legsState.splice(legsState.length - 1, 0, { name: '', km: '', hm: '', dropbag: false }); renderLegs(); }
  function removeLeg(i) { legsState.splice(i, 1); renderLegs(); }

  function sweatValue() {
    var measured = window.SportEnergyProfile ? window.SportEnergyProfile.getSweatRate() : null;
    if (measured) return measured;
    var r = document.querySelector('input[name="rk-sweat"]:checked');
    return r ? parseInt(r.value, 10) : 900;
  }
  function goalMinutes() {
    var h = $('rk-goal-h'), m = $('rk-goal-m');
    return ((h ? num(h.value) : 0) || 0) * 60 + ((m ? num(m.value) : 0) || 0);
  }
  function drinkCfg() {
    var d = selData('rk-drink');
    if (!d) return null;
    var r = document.querySelector('input[name="rk-mix"]:checked');
    return { carbsPerBottle: d.carbsG, sodiumPerBottle: d.sodiumMg, ratio: r ? num(r.value) : 1 };
  }

  function effectiveLegs() {
    if (!cumMode()) return { ok: true, legs: legsState };
    var conv = cumToLegs(legsState.map(function (L) { return L.km; }));
    if (!conv.ok) return conv;
    var out = [];
    for (var i = 0; i < legsState.length; i++) {
      out.push({ name: legsState[i].name, km: conv.legs[i], hm: legsState[i].hm, dropbag: legsState[i].dropbag });
    }
    return { ok: true, legs: out };
  }

  // ── FASE 4.15.0: Beregn én gang, rendrér i valgt visning ──
  var lastPlan = null, lastSolidsSel = null, lastDrinkLabel = null, lastGoalMin = null;
  // FASE 4.19.2: cartItems var aldrig erklæret — i streng tilstand
  // (som den minificerede live-fil kører i) kaster det ReferenceError
  // ved Byg. Roden til det tavse klik.
  var cartItems = [];
  // FASE 4.19.0: depoterne behøver ikke ramme distancen på decimalen —
  // vi bygger planen på depoterne og nævner roligt afvigelsen.
  var lastKmNote = null;
  function kmMismatch(legs) {
    var target = raceFrame().km;
    if (!target || target <= 0) return null;
    var sum = 0;
    for (var i = 0; i < legs.length; i++) sum += num(legs[i].km) || 0;
    sum = Math.round(sum * 10) / 10;
    var diff = Math.round((target - sum) * 10) / 10;
    if (Math.abs(diff) < 1) return null;
    var s1 = 'Dine depoter dækker ' + String(sum).replace('.', ',') + ' km af løbets ' + String(target).replace('.', ',') + ' — ';
    if (diff > 0) return s1 + 'der mangler cirka ' + String(diff).replace('.', ',') + ' km. Planen er bygget på depoterne, så tjek listen, hvis tallet overrasker.';
    return s1 + 'cirka ' + String(Math.abs(diff)).replace('.', ',') + ' km mere end sat. Planen er bygget på depoterne.';
  }
  var viewMode = 'leg'; // 'leg' (pr. ben) | 'hour' (pr. time)
  var legOver = {};     // ben-index -> variant-id (per-ben produkt-skift)
  var legExtra = {};    // ben-index -> [{ vid, qty }] (ekstra OVEN I de globale)

  function allSolidItems() {
    return productList(function (p) { return /gel|chew|crew|bar/i.test(p.v); }, 10);
  }

  function overrideData(i) {
    var vid = legOver[i];
    if (!vid) return null;
    var items = allSolidItems();
    for (var k = 0; k < items.length; k++) {
      if (String(items[k].vid) === String(vid)) return items[k];
    }
    return null;
  }

  function legsFromDOM() {
    var rows = document.querySelectorAll('#rk-legs .rk-leg');
    if (!rows.length) return;
    var read = [];
    for (var i = 0; i < rows.length; i++) {
      var ins = rows[i].querySelectorAll('input[type="text"]');
      var box = rows[i].querySelector('input[type="checkbox"]');
      read.push({
        name: ins[0] ? ins[0].value : '',
        km: ins[1] ? ins[1].value : '',
        hm: ins[2] ? ins[2].value : '',
        dropbag: !!(box && box.checked)
      });
    }
    legsState = read;
  }

  function calc() {
    try { calcInner(); } catch (e) {
      // FASE 4.19.1: en fejl må aldrig være tavs — vis den, så vi kan rette den.
      var out = $('rk-result');
      var msg = 'Noget gik galt i beregningen. Send os denne tekst, så retter vi det: ' + (e && e.message ? e.message : e);
      if (out) out.innerHTML = '<div class="sv-error">' + msg + '</div>';
      else if (window.alert) alert(msg);
    }
  }

  function calcInner() {
    var out = $('rk-result');
    if (!out) return;
    legsFromDOM();
    var frame = raceFrame();
    var depotMode = (raceType !== 'runde' && raceType !== 'crunde' && raceType !== 'backyard')
      && legsState.some(function (L) { return String(L.km || '').trim() !== ''; });
    if (!depotMode) {
      if (!frame.km || frame.km <= 0) {
        out.innerHTML = '<div class="sv-error">Skriv løbets distance (eller runder), så time-guiden kan regne.</div>';
        return;
      }
      calcQuick(frame, out);
      return;
    }
    var eff = effectiveLegs();
    if (!eff.ok) { out.innerHTML = '<div class="sv-error">' + eff.error + '</div>'; return; }
    var solidsSel = solidsCfg();
    // Per-ben overrides lægges på de effektive ben
    for (var i = 0; i < eff.legs.length; i++) {
      var od = overrideData(i);
      eff.legs[i].override = od ? { carbsG: od.carbsG, sodiumMg: od.sodiumMg } : null;
      eff.legs[i].extra = legExtraCfg(i); // FASE 4.26.0: ekstra oven i
    }
    var plan = computePlan({
      sport: sport,
      startClock: $('rk-start') ? $('rk-start').value : raceVals.start,
      goalMinutes: raceFrame().goal || goalMinutes(),
      carbsPerHour: num($('rk-carbs').value),
      sweatMlPerHour: sweatValue(),
      sodiumMgPerL: (function () {
        var r = document.querySelector('input[name="rk-salt"]:checked');
        return r ? num(r.value) : 650;
      })(),
      legs: eff.legs,
      solids: solidsSel,
      drink: drinkCfg(),
      caps: capsCfg(),
      adjustHm: !!($('rk-hm') && $('rk-hm').checked),
      caffeine: !!($('rk-caf') && $('rk-caf').checked)
    });
    if (!plan.ok) { out.innerHTML = '<div class="sv-error">' + plan.error + '</div>'; return; }
    lastPlan = plan;
    lastSolidsSel = solidsSel;
    lastDrinkLabel = selLabel('rk-drink');
    lastKmNote = kmMismatch(eff.legs);
    lastGoalMin = frame.goal || goalMinutes();
    renderPlan();
    updateURL();
  }

  function setMode(m) {
    viewMode = m === 'hour' ? 'hour' : 'leg';
    if (!lastPlan) return;
    // FASE 4.22.0: DOM'en genbygges ved skift, så CSS-transitioner kan
    // ikke bære overgangen — View Transitions crossfader i stedet.
    // Uden støtte: øjeblikkeligt skift, som hidtil.
    if (document.startViewTransition) {
      document.startViewTransition(function () { renderPlan(); });
    } else {
      renderPlan();
    }
  }

  function legSwap(i, vid) {
    if (vid) legOver[i] = vid; else delete legOver[i];
    calc();
  }

  // FASE 4.26.0: ekstra produkt pr. depot (additivt).
  function extraAdd(i, vid) {
    if (!vid) return;
    if (!legExtra[i]) legExtra[i] = [];
    // Samme produkt igen → hæv antallet i stedet for dublet-række.
    for (var k = 0; k < legExtra[i].length; k++) {
      if (String(legExtra[i][k].vid) === String(vid)) { legExtra[i][k].qty++; calc(); return; }
    }
    legExtra[i].push({ vid: vid, qty: 1 });
    calc();
  }
  function extraQty(i, k, delta) {
    if (!legExtra[i] || !legExtra[i][k]) return;
    legExtra[i][k].qty = Math.max(1, legExtra[i][k].qty + delta);
    calc();
  }
  function extraRemove(i, k) {
    if (!legExtra[i]) return;
    legExtra[i].splice(k, 1);
    if (!legExtra[i].length) delete legExtra[i];
    calc();
  }
  // Slår et ekstra-produkts vid op i produktlisten → {carbsG,sodiumMg,priceKr,label,vid}
  function extraData(vid) {
    var items = allSolidItems();
    for (var k = 0; k < items.length; k++) {
      if (String(items[k].vid) === String(vid)) return items[k];
    }
    // Kan også være en drik/tablet (bredere ekstra-liste)
    var wide = allExtraItems();
    for (var w = 0; w < wide.length; w++) {
      if (String(wide[w].vid) === String(vid)) return wide[w];
    }
    return null;
  }
  // Ekstra-listen er bredere end swap: gels/chews/barer PLUS drik-gels
  // og alt fast med kulhydrat — så man kan proppe en hård strækning op.
  function allExtraItems() {
    return productList(function (p) { return /gel|chew|crew|bar|drik|pulver|mix/i.test(p.v) && !/tablet|kapsel/i.test(p.v); }, 10);
  }
  // Byg motorens extra-array for et ben ud fra legExtra[i].
  function legExtraCfg(i) {
    if (!legExtra[i] || !legExtra[i].length) return null;
    var out = [];
    for (var k = 0; k < legExtra[i].length; k++) {
      var d = extraData(legExtra[i][k].vid);
      if (!d) continue;
      out.push({ c: d.carbsG, na: d.sodiumMg, qty: legExtra[i][k].qty, vid: d.vid, price: d.priceKr, label: d.label.replace(/ \([^)]*\)$/, '') });
    }
    return out.length ? out : null;
  }

  // Produktnavne for et ben: override-produktet eller de valgte typer
  function legProducts(L, i) {
    if (L.overridden) {
      var od = overrideData(i);
      return od ? [{ label: od.label.replace(/ \([^)]*\)$/, ''), vid: od.vid, priceKr: od.priceKr }] : [];
    }
    return lastSolidsSel;
  }

  function perHour(val, hours, rounder) {
    return rounder(val / hours);
  }

  // ── FASE 4.21.0: Resultatfladen — ikoner, hero-metrikker, dækning ──
  // Linje-ikoner (1,75 stroke) i samme sprog som trin-sektionerne.
  var RKI = {
    bolt: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2.5 4.8 13.4h6L9.6 21.5l8.6-11.1h-6L13 2.5z"/></svg>',
    drop: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3.5s5.5 6.1 5.5 10a5.5 5.5 0 1 1-11 0c0-3.9 5.5-10 5.5-10z"/></svg>',
    pack: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M4 8.5 12 4l8 4.5v7L12 20l-8-4.5v-7z"/><path d="M4 8.5 12 13l8-4.5"/><path d="M12 13v7"/></svg>',
    cards: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="7.5" width="12.5" height="12.5" rx="2.5"/><path d="M8 4h9.5A2.5 2.5 0 0 1 20 6.5V16"/></svg>',
    moon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M20 13.4A7.6 7.6 0 1 1 10.6 4 6.2 6.2 0 0 0 20 13.4z"/></svg>',
    coffee: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M5 9.5h10V14a4.5 4.5 0 0 1-4.5 4.5h-1A4.5 4.5 0 0 1 5 14V9.5z"/><path d="M15 10.5h1.4a2.3 2.3 0 0 1 0 4.6H15"/></svg>',
    bottle: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M10 3h4"/><path d="M10.5 3v3.2L8.8 9a3 3 0 0 0-.3 1.3V19a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2v-8.7a3 3 0 0 0-.3-1.3L13.5 6.2V3"/></svg>',
    flag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M5 21V4.6"/><path d="M5 5.2c2.4-1.5 4.9-1.5 7.3 0s4.9 1.5 7.3 0v7.6c-2.4 1.5-4.9 1.5-7.3 0s-4.9-1.5-7.3 0"/></svg>'
  };
  // Ikon-note: koffein, nat og mangler som scanbare rækker — advarsler
  // i samme rolige røde som tabellen, aldrig alarm.
  function noteRow(ico, inner, warn) {
    return '<div class="rk-note' + (warn ? ' rk-note-warn' : '') + '">'
      + '<span class="rk-note-ico">' + ico + '</span><p>' + inner + '</p></div>';
  }
  function fmtNum(n) { return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function fmtGoalHm(min) { var h = Math.floor(min / 60), m = Math.round(min) % 60; return h + ':' + (m < 10 ? '0' : '') + m; }
  function statTile(v, l) { return '<div class="rk-stat"><span class="rk-stat-v">' + v + '</span><span class="rk-stat-l">' + l + '</span></div>'; }
  // Dæknings-række: ramt mod mål med bar og procent. Under 90 % læses
  // som mangel — samme rolige røde som natrium-manglen i tabellen.
  // FASE 4.25.0: mangel UNDER 90 %, overdækning OVER 120 % (>20 % over)
  // — begge i den rolige røde. Imellem (også lidt over) er grønt.
  var OVER_PCT = 120;
  function covState(pct) { return pct < 90 ? 'short' : pct > OVER_PCT ? 'over' : 'ok'; }
  function covRow(ico, label, ach, tgt, unit) {
    if (!(tgt > 0) || isNaN(ach)) return '';
    var pct = Math.round(ach / tgt * 100);
    var w = Math.max(4, Math.min(100, pct));
    var st = covState(pct);
    var cls = st === 'short' ? ' rk-cov-short' : st === 'over' ? ' rk-cov-over' : '';
    return '<div class="rk-cov-row' + cls + '">'
      + '<span class="rk-cov-ico">' + ico + '</span>'
      + '<span class="rk-cov-meta"><span class="rk-cov-label">' + label + '</span>'
      + '<span class="rk-cov-num">' + fmtNum(ach) + ' af ' + fmtNum(tgt) + ' ' + unit + '</span></span>'
      + '<span class="rk-cov-bar"><span style="width:' + w + '%"></span></span>'
      + '<span class="rk-cov-pct">' + pct + '%</span></div>';
  }
  // Mini-bar i tabellens celler: ramt mod mål på fire pixels højde.
  // FASE 4.25.0: state 'over' (>20 % over) farver også rødt.
  function covMini(ach, tgt, forceShort) {
    if (!(tgt > 0) || !(ach > 0)) return '';
    var pct = Math.round(ach / tgt * 100);
    var w = Math.max(4, Math.min(100, pct));
    var st = forceShort ? 'short' : covState(pct);
    var cls = st === 'short' ? ' rk-mini-short' : st === 'over' ? ' rk-mini-over' : '';
    return '<span class="rk-mini' + cls + '"><span style="width:' + w + '%"></span></span>';
  }

  function renderPlan() {
    var out = $('rk-result');
    var plan = lastPlan, solidsSel = lastSolidsSel, drinkLabel = lastDrinkLabel;
    var hourMode = viewMode === 'hour';

    // FASE 4.21.0: rammen først som store fliser, dækningen som barer,
    // tabellen som detalje. Måltiden er den gemte — ikke udledt.
    var goalMin = lastGoalMin || Math.round(plan.paceMinPerKm * plan.totalKm);
    var finish = plan.legs[plan.legs.length - 1].clock;
    var aggTgtC = 0, aggAchC = 0, aggTgtNa = 0, aggAchNa = 0;
    for (var ag = 0; ag < plan.legs.length; ag++) {
      aggTgtC += plan.legs[ag].carbsG; aggAchC += plan.legs[ag].achievedCarbsG;
      aggTgtNa += plan.legs[ag].sodiumMg; aggAchNa += plan.legs[ag].achievedNaMg;
    }
    var hasIntake = !!(solidsSel.length || drinkLabel || (plan.totals && plan.totals.caps));
    // FASE 4.22.0: sv-pop kun når kortet er NYT — et visnings-skift er
    // ikke en entré, og en entré-animation der gentager sig, er støj.
    var isFirst = !out.querySelector('.sv-result-card');
    var html = '<div class="sv-result-card rk-plan' + (isFirst ? ' sv-pop' : '') + '">'
      + '<div class="rk-print-head">Sport Energy · Race-plan</div>'
      + '<div class="sv-result-kicker">Din race-plan</div>'
      + '<div class="rk-stats">'
      + statTile(String(plan.totalKm).replace('.', ','), 'km')
      + statTile(fmtGoalHm(goalMin), 'måltid')
      + statTile(finish, 'i mål ca. kl.')
      + (plan.sport === 'bike' ? statTile(fmtSpeed(plan.paceMinPerKm), 'km/t') : statTile(fmtPace(plan.paceMinPerKm), 'min/km'))
      + '</div>'
      + (hasIntake ? '<div class="rk-cov">'
          + covRow(RKI.bolt, 'Kulhydrat', aggAchC, aggTgtC, 'g')
          + covRow(RKI.drop, 'Natrium', aggAchNa, aggTgtNa, 'mg')
          + '</div>' : '')
      + '<p class="sv-result-note">Målene er retning, ikke facit — justér efter dagen.</p>'
      + (lastKmNote ? '<p class="sv-result-note">' + lastKmNote + '</p>' : '')
      + (plan.hmAdjusted ? '<p class="sv-result-note">Tiden er fordelt efter stigning — 100 hm tæller som cirka ' + (plan.sport === 'bike' ? '2' : '0,8') + ' km ekstra. Din måltid er uændret.</p>' : '')
      + (plan.overCovered ? '<p class="sv-result-note">Din drik dækker mere kulhydrat end målet på nogle strækninger — overvej færre blandede flasker, eller se det som buffer.</p>' : '');
    if (plan.sodiumShort) {
      html += noteRow(RKI.drop, 'Du får ikke nok natrium fra produkterne på alle strækninger — tilføj elektrolyt-kapsler under Natrium, eller vælg produkter med mere salt.', true);
    }

    // Visnings-toggle: pr. ben ⇄ pr. time
    html += '<div class="rk-viewtoggle" role="group" aria-label="Visning">'
      + '<button type="button" class="rk-view' + (hourMode ? '' : ' rk-view-on') + '" onclick="RK.setMode(\'leg\')">Pr. strækning</button>'
      + '<button type="button" class="rk-view' + (hourMode ? ' rk-view-on' : '') + '" onclick="RK.setMode(\'hour\')">Pr. time</button>'
      + '</div>';

    // FASE 4.23.0: Planen som depot-tidslinje — ruten er metaforen.
    // Noder: prik (depot), pakke (dropbag), flag (mål). Ankomsten er
    // det største tal på kortet; doserne er chips med dæknings-barer.
    // Samme data og toggle som tabellen — kun formen er ny.
    html += '<ol class="rk-tl" aria-label="Plan pr. strækning">';
    for (var i = 0; i < plan.legs.length; i++) {
      var L = plan.legs[i];
      var isGoal = i === plan.legs.length - 1;
      var h = Math.max(L.minutes / 60, 0.01);
      var carbsShow = hourMode ? Math.round(L.carbsG / h) : L.carbsG;
      var achC = hourMode ? Math.round(L.achievedCarbsG / h) : L.achievedCarbsG;
      var diffC = achC - carbsShow;
      var fluidShow = hourMode ? Math.round(L.fluidMl / h / 50) * 50 : L.fluidMl;
      var botShow = hourMode ? L.bottlesPerHour : L.bottles;
      var naShow = hourMode ? Math.round(L.sodiumMg / h / 10) * 10 : L.sodiumMg;
      var achNa = hourMode ? Math.round(L.achievedNaMg / h / 10) * 10 : L.achievedNaMg;
      var naShort = L.naShortMg >= 100;
      var node = isGoal ? RKI.flag : (L.dropbag ? RKI.pack : '');
      var tags = '';
      if (L.dropbag) tags += '<span class="rk-tl-tag">Dropbag</span>';
      if (L.hm) tags += '<span class="rk-tl-tag">' + L.hm + ' hm</span>';
      if (L.nightLeg) tags += '<span class="rk-tl-tag rk-tl-tag-ico" title="Mørk strækning">' + RKI.moon + '</span>';
      if (L.caffeineLeg) tags += '<span class="rk-tl-tag rk-tl-tag-ico" title="Koffein-vindue">' + RKI.coffee + '</span>';
      html += '<li class="rk-tl-leg' + (isGoal ? ' is-goal' : '') + '">'
        + '<span class="rk-tl-node" aria-hidden="true">' + node + '</span>'
        + '<div class="rk-tl-card">'
        + '<div class="rk-tl-head">'
        + '<div class="rk-tl-name">' + L.name + tags + '</div>'
        + '<div class="rk-tl-eta"><strong>' + L.clock + '</strong><span>fremme ca.</span></div>'
        + '</div>'
        + '<div class="rk-tl-sub">' + String(L.km).replace('.', ',') + ' km · ca. ' + L.durationLabel + '</div>'
        + '<div class="rk-tl-stats">'
        + '<div class="rk-tl-stat"><small>Kulhydrat</small><b>' + carbsShow + ' g</b>'
        +   '<small>rammer ' + achC + ' g' + (diffC ? ' (' + (diffC > 0 ? '+' : '') + diffC + ')' : '')
        +   (L.drinkCarbsG ? ' · ' + (hourMode ? Math.round(L.drinkCarbsG / h) : L.drinkCarbsG) + ' g fra drik' : '') + '</small>'
        +   covMini(L.achievedCarbsG, L.carbsG, false) + '</div>'
        + '<div class="rk-tl-stat"><small>Væske</small><b>' + fluidShow + ' ml</b>'
        +   '<small>' + fmtHalf(botShow) + ' flasker</small>'
        +   covMini(L.fluidMl, L.fluidMl, false) + '</div>'
        + '<div class="rk-tl-stat"><small>Natrium</small><b>' + naShow + ' mg</b>'
        +   '<small>rammer ' + achNa + ' mg</small>'
        +   (naShort ? '<small class="rk-na-short">mangler ' + (hourMode ? Math.round(L.naShortMg / h / 10) * 10 : L.naShortMg) + ' mg</small>' : '')
        +   covMini(L.achievedNaMg, L.sodiumMg, naShort) + '</div>'
        + '</div>'
        + prodCell(L, i, hourMode, h)
        + '</div></li>';
    }
    html += '</ol>';

    // Sådan pakker du — KUN produkter (gram fjernet; svært at forholde sig til)
    html += '<button type="button" class="fold-toggle rk-fold" aria-expanded="false" onclick="RK.fold(this)"><span class="fold-kicker"><span class="rk-fold-ico">' + RKI.pack + '</span>Sådan pakker du</span><span class="fold-caret">▾</span></button>';
    html += '<div class="rk-pack" hidden>';
    var segStart = 0;
    for (i = 0; i < plan.packing.length; i++) {
      var P = plan.packing[i];
      // Produkt-summer for segmentets ben (håndterer per-ben overrides)
      var segMap = {}, segEnd = segStart;
      for (var li = segStart; li < plan.legs.length; li++) {
        var SL = plan.legs[li];
        var prods = legProducts(SL, li);
        if (SL.solidUnits) {
          for (var pi = 0; pi < SL.solidUnits.length; pi++) {
            if (SL.solidUnits[pi] > 0 && prods[pi]) {
              var key = prods[pi].label;
              segMap[key] = (segMap[key] || 0) + SL.solidUnits[pi];
            }
          }
        }
        // FASE 4.26.0: ekstra-produkter tæller også i pakningen
        if (SL.extras) {
          for (var ext = 0; ext < SL.extras.length; ext++) {
            var EX = SL.extras[ext];
            segMap[EX.label] = (segMap[EX.label] || 0) + EX.qty;
          }
        }
        segEnd = li;
        if (SL.dropbag || li === plan.legs.length - 1) break;
      }
      segStart = segEnd + 1;
      var parts = [];
      for (var key2 in segMap) {
        if (Object.prototype.hasOwnProperty.call(segMap, key2)) parts.push(fmtHalf(Math.ceil(segMap[key2] * 2) / 2) + ' × ' + key2);
      }
      if (P.drinkPortions) parts.push(P.drinkPortions + ' portion' + (P.drinkPortions === 1 ? '' : 'er') + ' ' + (drinkLabel || 'drik'));
      if (P.caps) parts.push(P.caps + ' kapsler');
      html += '<p class="sv-result-line">Fra ' + P.from + ' til ' + P.to + ': <strong>' + (parts.length ? parts.join(' · ') : 'kun væske') + '</strong></p>';
    }
    if (plan.caffeine) {
      html += noteRow(RKI.coffee, 'Koffein-vindue: <strong>fra ' + plan.caffeine.clock + '</strong> — på strækningen mod ' + plan.caffeine.beforeLeg + '. Sidste tredjedel er der, hvor det bærer mest.');
    }
    if (plan.night) {
      html += noteRow(RKI.moon, 'Mørke strækninger: <strong>' + plan.night.legs.join(', ') + '</strong>. Pandelampe ' + plan.night.headlampFrom + ' — læg den i dropbag\'en før, hvis du ikke vil bære den fra start.');
    }
    html += '</div>';

    // Depot-kortene (fold)
    html += '<button type="button" class="fold-toggle rk-fold" aria-expanded="false" onclick="RK.fold(this)"><span class="fold-kicker"><span class="rk-fold-ico">' + RKI.cards + '</span>Dine depot-kort</span><span class="fold-caret">▾</span></button>'
      + '<div class="rk-cards-wrap" hidden>'
      + '<p class="sv-result-note rk-cards-intro">Ét kort pr. strækning — print, klip og laminér. Tag næste kort frem i depotet, og ' + (plan.sport === 'bike' ? 'kør' : 'løb') + ' kun den strækning, du er på.</p>'
      + '<div class="rk-cards">';
    var prev = 'Start';
    for (i = 0; i < plan.legs.length; i++) {
      var C = plan.legs[i];
      var ch = Math.max(C.minutes / 60, 0.01);
      var cprods = legProducts(C, i);
      html += '<div class="rk-card">'
        + '<div class="rk-card-head"><span>' + prev + '</span><span class="rk-card-arrow">→</span><span>' + C.name + (C.dropbag ? ' • DROPBAG' : '') + '</span></div>'
        + '<div class="rk-card-stats">' + String(C.km).replace('.', ',') + ' km' + (C.hm ? ' · ' + C.hm + ' hm' : '') + ' · ca. ' + C.durationLabel + '</div>'
        + '<div class="rk-card-eta">Fremme ca. kl. ' + C.clock + '</div>';
      var hourBits = [];
      if (C.bottlesPerHour) hourBits.push(fmtHalf(C.bottlesPerHour) + ' flaske' + (C.bottlesPerHour > 1 ? 'r' : ''));
      if (C.solidUnits) {
        for (var hb = 0; hb < C.solidUnits.length; hb++) {
          var uph = Math.round(C.solidUnits[hb] / ch * 2) / 2;
          if (uph > 0 && cprods[hb]) hourBits.push(fmtHalf(uph) + ' × ' + cprods[hb].label);
        }
      }
      if (hourBits.length) html += '<div class="rk-card-hour">Pr. time: ' + hourBits.join(' · ') + '</div>';
      var packBits = [];
      var mixWord = plan.drinkRatio === 1 ? 'alle med ' : plan.drinkRatio ? fmtHalf(Math.round(C.drinkRaw * 2) / 2) + ' med ' : '';
      if (C.bottles) packBits.push(fmtHalf(C.bottles) + ' flasker' + (mixWord ? ' (' + mixWord + (drinkLabel || 'drik') + ')' : ''));
      if (C.solidUnits) {
        for (var pb = 0; pb < C.solidUnits.length; pb++) {
          if (C.solidUnits[pb] > 0 && cprods[pb]) packBits.push(fmtHalf(C.solidUnits[pb]) + ' × ' + cprods[pb].label);
        }
      }
      if (C.caps) packBits.push(C.caps + ' kapsler');
      if (packBits.length) html += '<div class="rk-card-pack">I lommerne: ' + packBits.join(' · ') + '</div>';
      var notes = [];
      if (C.nightLeg) notes.push('Nat: pandelampe, vindjakke, handsker');
      if (C.caffeineLeg) notes.push('Koffein-vindue: tag koffein-gels frem');
      if (notes.length) html += '<div class="rk-card-note">' + notes.join(' · ') + '</div>';
      html += '</div>';
      prev = C.name;
    }
    html += '</div>'
      + '<p class="sv-result-note">Bær første del på dig fra start, genopfyld ved hver dropbag. Væsken dækkes ved depoterne eller fra det, du bærer — én flaske er 500 ml.</p>'
      + '</div>';

    html += cartHtml(plan)
      + '<div class="sv-actions"><button type="button" class="sv-save" onclick="RK.copyLink()" id="rk-copy">Kopiér link til planen</button>'
      + '<button type="button" class="sv-cta rk-print" onclick="RK.printCards()">Print depot-kortene</button></div></div>';
    out.innerHTML = html;
  }

  function calcQuick(frame, out) {
    var plan = computePlan({
      sport: sport,
      startClock: $('rk-start') ? $('rk-start').value : raceVals.start,
      goalMinutes: frame.goal,
      carbsPerHour: num($('rk-carbs').value),
      sweatMlPerHour: sweatValue(),
      sodiumMgPerL: saltValue(),
      legs: [{ km: frame.km, name: 'Mål' }],
      solids: solidsCfg().map(function (x) { return { carbsG: x.carbsG, sodiumMg: x.sodiumMg }; }),
      drink: drinkCfg(),
      caps: capsCfg(),
      caffeine: !!($('rk-caf') && $('rk-caf').checked)
    });
    if (!plan.ok) { out.innerHTML = '<div class="sv-error">' + plan.error + '</div>'; return; }
    lastPlan = plan; lastSolidsSel = solidsCfg(); lastDrinkLabel = selLabel('rk-drink');
    lastKmNote = null;
    var L = plan.legs[0];
    var h = Math.max(0.1, L.minutes / 60);
    var typeObj = raceTypes().filter(function (x) { return x.key === raceType; })[0];
    var typeLabel = typeObj ? typeObj.label : '';
    var hourBits = [];
    if (L.bottlesPerHour) hourBits.push(fmtHalf(L.bottlesPerHour) + ' flaske' + (L.bottlesPerHour > 1 ? 'r' : '') + (lastDrinkLabel ? ' (' + lastDrinkLabel + ')' : ' vand'));
    if (L.solidUnits) {
      for (var i = 0; i < L.solidUnits.length; i++) {
        var uph = Math.round(L.solidUnits[i] / h * 2) / 2;
        if (uph > 0 && lastSolidsSel[i]) hourBits.push(fmtHalf(uph) + ' × ' + lastSolidsSel[i].label);
      }
    }
    if (L.caps) {
      var cph2 = Math.round(L.caps / h * 2) / 2;
      if (cph2 > 0) hourBits.push(fmtHalf(cph2) + ' kapsler');
    }
    var isFirst = !out.querySelector('.sv-result-card');
    var html = '<div class="sv-result-card rk-plan' + (isFirst ? ' sv-pop' : '') + '">'
      + '<div class="rk-print-head">Sport Energy · Time-guide</div>'
      + '<div class="sv-result-kicker">Din time-guide · ' + typeLabel + '</div>'
      + '<div class="rk-stats">'
      + statTile(String(plan.totalKm).replace('.', ','), 'km')
      + statTile(fmtGoalHm(L.minutes), 'ca. tid')
      + statTile(L.clock, 'i mål ca. kl.')
      + (raceVals.hm && raceType === 'ultra' ? statTile(String(raceVals.hm), 'højdemeter') : '')
      + '</div>';
    html += '<div class="rk-hourly">'
      + '<div class="rk-hour-num"><span class="rk-hour-ico">' + RKI.bolt + '</span>' + Math.round(num($('rk-carbs').value)) + ' g <span>kulhydrat i timen</span></div>'
      + '<div class="rk-hour-num"><span class="rk-hour-ico">' + RKI.bottle + '</span>' + round50ui(L.fluidMl / h) + ' ml <span>væske i timen</span></div>'
      + '<div class="rk-hour-num"><span class="rk-hour-ico">' + RKI.drop + '</span>' + Math.round(L.sodiumMg / h / 10) * 10 + ' mg <span>natrium i timen</span></div>'
      + '</div>';
    if (hourBits.length) {
      html += '<p class="sv-result-line">Det svarer til, i timen: <strong>' + hourBits.join(' · ') + '</strong></p>';
    }
    var achH = Math.round(L.achievedCarbsG / h);
    if (lastSolidsSel.length || lastDrinkLabel || plan.totals.caps) {
      var tgtH = Math.round(num($('rk-carbs').value));
      var naTgtH = Math.round(L.sodiumMg / h / 10) * 10;
      var naAchH = Math.round(L.achievedNaMg / h / 10) * 10;
      html += '<div class="rk-cov">'
        + covRow(RKI.bolt, 'Kulhydrat i timen', achH, tgtH, 'g')
        + covRow(RKI.drop, 'Natrium i timen', naAchH, naTgtH, 'mg')
        + '</div>';
    }
    if (L.naShortMg >= 100) {
      html += noteRow(RKI.drop, 'Du mangler natrium — tilføj elektrolyt-kapsler under Natrium, eller vælg en drik med mere salt.', true);
    }
    if (plan.caffeine) {
      html += noteRow(RKI.coffee, 'Koffein-vindue: <strong>fra ' + plan.caffeine.clock + '</strong> — sidste tredjedel er der, hvor det bærer mest.');
    }
    if (plan.night) {
      html += noteRow(RKI.moon, 'Du rammer mørket: pandelampe ' + plan.night.headlampFrom + ' — og læg vindjakke og handsker klar; natten er koldere, end den ser ud.');
    }
    if (raceType === 'backyard') {
      html += '<p class="sv-result-note">Backyard-rytme: indtag i paddocken hver hele time — planen ovenfor ER din runde-rytme.</p>';
    } else if (raceType === 'runde' || raceType === 'crunde') {
      html += '<p class="sv-result-note">Rundeløb: fordel timens indtag over runde-passagerne, så maven får det jævnt.</p>';
    }
    html += cartHtml(plan, lastSolidsSel, lastDrinkLabel)
      + '<div class="sv-actions"><button type="button" class="sv-save" onclick="RK.copyLink()" id="rk-copy">Kopiér link til planen</button></div></div>';
    out.innerHTML = html;
    updateURL();
  }

  function round50ui(x) { return Math.round(x / 50) * 50; }

  // FASE 4.17.0: Tærsklen skal være lav — velkomst med tre trin og
  // et eksempel på ét tryk, så værktøjet viser sig selv frem.
  function renderEmptyState() {
    var out = $('rk-result');
    if (!out || out.innerHTML.trim() !== '') return;
    out.innerHTML = '<div class="rk-empty sv-pop">'
      + '<div class="sv-result-kicker">Sådan virker det</div>'
      + '<div class="rk-empty-row"><span class="rk-empty-num">1</span><p>Vælg sport og løbstype, og skriv din måltid — det er nok til en time-guide.</p></div>'
      + '<div class="rk-empty-row"><span class="rk-empty-num">2</span><p>Vælg dine produkter, hvis du vil have antal og kurv med.</p></div>'
      + '<div class="rk-empty-row"><span class="rk-empty-num">3</span><p>Tilføj depoter, hvis du vil planlægge hele racet — med depot-kort til lommen.</p></div>'
      + '<button type="button" class="sv-save rk-demo" onclick="RK.demo()">Se et eksempel — maraton på 4 timer</button>'
      + '</div>';
  }

  function pickOption(sel, want) {
    if (!sel) return false;
    for (var i = 1; i < sel.options.length; i++) {
      if (sel.options[i].text.toLowerCase().indexOf(want) >= 0) { sel.selectedIndex = i; return true; }
    }
    if (sel.options.length > 1) { sel.selectedIndex = 1; return true; }
    return false;
  }

  function demo() {
    // Eksemplet er et løbe-maraton — stil sporten tilbage, hvis
    // atleten stod på cykel, og hold radioen i trin 1 i sync.
    if (sport !== 'run') {
      sport = 'run';
      var sr = document.querySelector('input[name="rk-sport"][value="run"]');
      if (sr) sr.checked = true;
      fillTemplates();
    }
    setRaceType('maraton');
    raceVals.gh = '4'; raceVals.gm = '0'; raceVals.start = '09:00';
    renderRaceFields();
    if ($('rk-goal-h')) $('rk-goal-h').value = '4';
    if ($('rk-goal-m')) $('rk-goal-m').value = '0';
    if ($('rk-start')) $('rk-start').value = '09:00';
    if ($('rk-carbs')) { $('rk-carbs').value = '75'; lastAutoCarbs = 75; }
    var sol = $('rk-solid-0');
    if (sol && sol.selectedIndex <= 0 && pickOption(sol, 'maurten gel 100')) {
      solidsState[0].vid = sol.value;
    }
    var dr = $('rk-drink');
    if (dr && dr.selectedIndex <= 0) pickOption(dr, 'maurten drink mix 160');
    calc();
    var out = $('rk-result');
    if (out && out.firstChild) {
      var note = document.createElement('p');
      note.className = 'sv-result-note';
      note.textContent = 'Dette er et eksempel — justér tallene og produkterne, så de bliver dine.';
      out.firstChild.insertBefore(note, out.firstChild.children[1] || null);
      try { out.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
    }
  }

  function saltValue() {
    var r = document.querySelector('input[name="rk-salt"]:checked');
    return r ? num(r.value) : 650;
  }

  function selLabel(id) {
    var s = $(id);
    return s && s.selectedIndex > 0 ? s.options[s.selectedIndex].text.replace(/ \([^)]*\)$/, '') : null;
  }

  // Produkt-linjen i tidslinje-kortets fod + skift-vælger pr. ben
  function prodCell(L, i, hourMode, h) {
    var lines = [];
    var prods = legProducts(L, i);
    if (L.solidUnits) {
      for (var k = 0; k < L.solidUnits.length; k++) {
        var u = hourMode ? Math.round(L.solidUnits[k] / h * 2) / 2 : L.solidUnits[k];
        if (u > 0 && prods[k]) lines.push(fmtHalf(u) + ' × ' + prods[k].label);
      }
    }
    if (L.drinkPortions && !hourMode) lines.push(L.drinkPortions + ' portion' + (L.drinkPortions === 1 ? '' : 'er') + ' drik');
    if (L.caps && !hourMode) lines.push(L.caps + ' kapsler');
    // FASE 4.26.0: ekstra-produkter vises som egne linjer med + foran
    if (L.extras && L.extras.length && !hourMode) {
      for (var ex = 0; ex < L.extras.length; ex++) {
        lines.push('+ ' + L.extras[ex].qty + ' × ' + L.extras[ex].label);
      }
    }
    // Skift-vælger: atleter der vil justere enkelte sektioner
    var items = allSolidItems();
    var sel = '<select class="rk-swap" aria-label="Skift produkt på denne strækning" onchange="RK.legSwap(' + i + ', this.value)">'
      + '<option value="">' + (L.overridden ? 'Tilbage til dine valgte' : 'Skift produkt på strækningen') + '</option>';
    for (var m = 0; m < items.length; m++) {
      sel += '<option value="' + items[m].vid + '"' + (String(legOver[i] || '') === String(items[m].vid) ? ' selected' : '') + '>' + items[m].label + '</option>';
    }
    sel += '</select>';
    // FASE 4.26.0: ekstra-vælger + antal-justering pr. valgt ekstra
    var extraItems = allExtraItems();
    var extraSel = '<select class="rk-swap rk-extra-sel" aria-label="Tilføj ekstra produkt på denne strækning" onchange="RK.extraAdd(' + i + ', this.value); this.selectedIndex=0;">'
      + '<option value="">+ Tilføj ekstra her</option>';
    for (var e = 0; e < extraItems.length; e++) {
      extraSel += '<option value="' + extraItems[e].vid + '">' + extraItems[e].label + '</option>';
    }
    extraSel += '</select>';
    var extraRows = '';
    if (legExtra[i] && legExtra[i].length) {
      extraRows = '<div class="rk-extra-list">';
      for (var er = 0; er < legExtra[i].length; er++) {
        var ed = extraData(legExtra[i][er].vid);
        var elabel = ed ? ed.label.replace(/ \([^)]*\)$/, '') : 'Ekstra';
        extraRows += '<div class="rk-extra-row"><span class="rk-extra-name">' + elabel + '</span>'
          + '<span class="rk-extra-stepper">'
          + '<button type="button" aria-label="Færre" onclick="RK.extraQty(' + i + ',' + er + ',-1)">−</button>'
          + '<b>' + legExtra[i][er].qty + '</b>'
          + '<button type="button" aria-label="Flere" onclick="RK.extraQty(' + i + ',' + er + ',1)">+</button>'
          + '</span>'
          + '<button type="button" class="rk-extra-x" aria-label="Fjern ekstra" onclick="RK.extraRemove(' + i + ',' + er + ')">×</button>'
          + '</div>';
      }
      extraRows += '</div>';
    }
    return '<div class="rk-tl-prods"><span>' + (lines.length ? lines.join(' · ') : 'Kun væske på strækningen') + '</span>'
      + '<div class="rk-tl-selects">' + sel + extraSel + '</div></div>' + extraRows;
  }

  // Kurv: alle produkter på tværs af ben (inkl. per-ben overrides)
  function cartHtml(plan) {
    cartItems = [];
    var cartTotalKr = 0;
    var agg = {};
    for (var i = 0; i < plan.legs.length; i++) {
      var L = plan.legs[i];
      var prods = legProducts(L, i);
      if (L.solidUnits) {
        for (var k = 0; k < L.solidUnits.length; k++) {
          if (L.solidUnits[k] > 0 && prods[k] && prods[k].vid) {
            var key = prods[k].vid;
            if (!agg[key]) agg[key] = { qty: 0, label: prods[k].label, price: prods[k].priceKr || 0 };
            agg[key].qty += L.solidUnits[k];
          }
        }
      }
      // FASE 4.26.0: ekstra-produkter i kurven (kun dem med gyldigt vid)
      if (L.extras && L.extras.length) {
        for (var ex = 0; ex < L.extras.length; ex++) {
          var E = L.extras[ex];
          if (!E.vid || String(E.vid) === '0') continue;
          if (!agg[E.vid]) agg[E.vid] = { qty: 0, label: E.label, price: E.price || 0 };
          agg[E.vid].qty += E.qty;
        }
      }
    }
    // FASE 4.21.0: kurven som liste — produkt til venstre, antal til højre.
    var rows = [];
    function cartRow(label, qtyText) {
      rows.push('<li><span>' + label + '</span><span class="rk-cart-qty">' + qtyText + '</span></li>');
    }
    for (var vid in agg) {
      if (!Object.prototype.hasOwnProperty.call(agg, vid)) continue;
      // FASE 4.24.2: aldrig et 0/tomt id i kurv-kaldet (defensivt).
      if (!vid || vid === '0') continue;
      var q = Math.ceil(agg[vid].qty);
      cartItems.push({ id: vid, quantity: q });
      cartRow(agg[vid].label, q + ' stk');
      cartTotalKr += q * agg[vid].price;
    }
    var dd = selData('rk-drink');
    if (dd && dd.vid && String(dd.vid) !== '0' && plan.totals.drinkPortions) {
      cartItems.push({ id: dd.vid, quantity: plan.totals.drinkPortions });
      cartRow(lastDrinkLabel || 'Drik', plan.totals.drinkPortions + ' portion' + (plan.totals.drinkPortions === 1 ? '' : 'er'));
      cartTotalKr += plan.totals.drinkPortions * dd.priceKr;
    }
    var cd = selData('rk-caps');
    if (cd && cd.vid && String(cd.vid) !== '0' && plan.totals.caps) {
      cartItems.push({ id: cd.vid, quantity: plan.totals.caps });
      cartRow(selLabel('rk-caps') || 'Elektrolyt-kapsler', plan.totals.caps + ' stk');
      cartTotalKr += plan.totals.caps * cd.priceKr;
    }
    if (!rows.length) return '';
    return '<div class="rk-cart"><div class="sv-result-kicker">Hele racet, samlet</div>'
      + '<ul class="rk-cart-list">' + rows.join('') + '</ul>'
      + '<p class="sv-result-note">Justér selv i kurven, hvis du køber bokse frem for enkeltstyk.</p>'
      + '<button type="button" class="sv-save se-style-atc" onclick="RK.addToCart(this)">'
      + '<span class="se-atc-text">Læg produkterne i kurven</span>'
      + (cartTotalKr > 0 ? '<span class="se-atc-total">' + Math.round(cartTotalKr) + ' kr.</span>' : '')
      + '</button></div>';
  }

  function addToCart(btn) {
    // FASE 4.24.2: sidste værn — fjern ethvert 0/tomt id, så ét dårligt
    // produkt aldrig afviser hele batchet.
    cartItems = cartItems.filter(function (it) {
      return it && it.id && String(it.id) !== '0' && it.quantity > 0;
    });
    if (!cartItems.length) return;
    btn.disabled = true;
    btn.innerHTML = '<span class="se-atc-text">Lægger i kurven…</span>';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: cartItems })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      if (navigator.vibrate) { try { navigator.vibrate(10); } catch (e) {} }
      btn.classList.add('is-added');
      btn.innerHTML = '<span class="se-atc-text">Lagt i kurven</span>';
    }).catch(function () {
      btn.disabled = false;
      btn.classList.remove('is-added');
      btn.innerHTML = '<span class="se-atc-text">Kunne ikke lægge i kurven — prøv igen</span>';
    });
  }

  function fold(btn) {
    var body = btn.nextElementSibling;
    if (!body) return;
    var open = body.hidden;
    body.hidden = !open;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function printCards() {
    // Kortene skal være udfoldede, når de printes
    var wrap = document.querySelector('.rk-cards-wrap');
    if (wrap) wrap.hidden = false;
    document.body.classList.add('rk-print-cards');
    var cleanup = function () { document.body.classList.remove('rk-print-cards'); };
    if (window.matchMedia) {
      window.addEventListener('afterprint', cleanup, { once: true });
    }
    window.print();
    setTimeout(cleanup, 2000);
  }

  function fmtPace(p) { var m = Math.floor(p), s = Math.round((p - m) * 60); if (s === 60) { m++; s = 0; } return m + ':' + (s < 10 ? '0' : '') + s; }
  // FASE 4.24.0: cykel viser fart, ikke tempo — km/t med én decimal.
  function fmtSpeed(paceMinPerKm) { var v = Math.round(600 / paceMinPerKm) / 10; return String(v).replace('.', ','); }
  function fmtHalf(u) { return ('' + u).replace('.5', '½').replace(/^0½/, '½'); }
  // rowHtml udgået i 4.23.0 — planen renderes som depot-tidslinje (rk-tl).

  // ── URL-state: navne URI-kodes, felter adskilles med , og ben med ; ──
  function updateURL() {
    try {
      var p = new URLSearchParams();
      if ($('rk-start')) p.set('st', $('rk-start').value);
      if ($('rk-goal-h')) p.set('gh', $('rk-goal-h').value);
      if ($('rk-goal-m')) p.set('gm', $('rk-goal-m').value);
      p.set('c', $('rk-carbs').value);
      if (cumMode()) p.set('mode', 'cum');
      if ($('rk-hm') && $('rk-hm').checked) p.set('ah', '1');
      if ($('rk-caf') && $('rk-caf').checked) p.set('cf', '1');
      var measured = window.SportEnergyProfile ? window.SportEnergyProfile.getSweatRate() : null;
      if (!measured) { var r = document.querySelector('input[name="rk-sweat"]:checked'); if (r) p.set('sw', r.value); }
      var salt = document.querySelector('input[name="rk-salt"]:checked'); if (salt) p.set('na', salt.value);
      // (na er nu 450/650/1000 — gamle links med na=salt mappes ved læsning)
      if (sport === 'bike') p.set('sp', 'bike');
      p.set('rt', raceType);
      if (raceVals.km) p.set('rd', raceVals.km);
      if (raceVals.hm) p.set('rhm', raceVals.hm);
      if (raceVals.hours) p.set('rh', raceVals.hours);
      if (raceVals.rounds) p.set('rr', raceVals.rounds);
      var solParts = [];
      for (var sx = 0; sx < solidsState.length; sx++) {
        if (solidsState[sx].vid) solParts.push(solidsState[sx].cat + ':' + solidsState[sx].vid);
      }
      if (solParts.length) p.set('sol', solParts.join(','));
      if ($('rk-drink').value) {
        p.set('did', $('rk-drink').value);
      }
      if ($('rk-caps') && $('rk-caps').value) {
        p.set('cid', $('rk-caps').value);
        var mx = document.querySelector('input[name="rk-mix"]:checked'); if (mx) p.set('mx', mx.value);
      }
      p.set('legs', legsState.map(function (L) {
        return [encodeURIComponent(L.name || ''), L.km || '', L.hm || '', L.dropbag ? 1 : 0].join(',');
      }).join(';'));
      // FASE 4.26.0: ekstra-produkter pr. ben — 'benindex:vid:antal,...'
      var exParts = [];
      for (var exk in legExtra) {
        if (!Object.prototype.hasOwnProperty.call(legExtra, exk)) continue;
        for (var exj = 0; exj < legExtra[exk].length; exj++) {
          exParts.push(exk + ':' + legExtra[exk][exj].vid + ':' + legExtra[exk][exj].qty);
        }
      }
      if (exParts.length) p.set('ex', exParts.join(','));
      history.replaceState(null, '', window.location.pathname + '?' + p.toString());
    } catch (e) {}
  }

  function loadURL() {
    try {
      var p = new URLSearchParams(window.location.search);
      // FASE 4.24.0: sporten læses før løbstypen — gamle links uden
      // sp-parameter er løb. Radioen i trin 1 følger med.
      if (p.get('sp') === 'bike') {
        sport = 'bike';
        var sb = document.querySelector('input[name="rk-sport"][value="bike"]');
        if (sb) sb.checked = true;
        fillTemplates();
      }
      if (p.has('rt')) {
        var rt0 = p.get('rt'), RTS0 = raceTypes();
        for (var ri = 0; ri < RTS0.length; ri++) {
          if (RTS0[ri].key === rt0) { raceType = rt0; break; }
        }
      }
      if (p.has('rd')) raceVals.km = p.get('rd');
      if (p.has('rhm')) raceVals.hm = p.get('rhm');
      if (p.has('rh')) raceVals.hours = p.get('rh');
      if (p.has('rr')) raceVals.rounds = p.get('rr');
      if (p.has('st')) raceVals.start = p.get('st');
      if (p.has('gh')) raceVals.gh = p.get('gh');
      if (p.has('gm')) raceVals.gm = p.get('gm');
      renderRaceFields();
      if ($('rk-start')) $('rk-start').value = raceVals.start;
      if ($('rk-goal-h')) $('rk-goal-h').value = raceVals.gh;
      if ($('rk-goal-m')) $('rk-goal-m').value = raceVals.gm;
      if (p.has('c')) $('rk-carbs').value = p.get('c');
      if (p.get('mode') === 'cum' && $('rk-cum')) $('rk-cum').checked = true;
      if (p.get('ah') === '1' && $('rk-hm')) $('rk-hm').checked = true;
      if (p.get('cf') === '1' && $('rk-caf')) $('rk-caf').checked = true;
      if (p.has('sw')) { var r = document.querySelector('input[name="rk-sweat"][value="' + p.get('sw') + '"]'); if (r) r.checked = true; }
      var naP = p.get('na') === 'salt' ? '1000' : p.get('na');
      if (naP) { var s = document.querySelector('input[name="rk-salt"][value="' + naP + '"]'); if (s) s.checked = true; }
      if (p.has('sol')) {
        var parsedSol = p.get('sol').split(',').map(function (x) {
          var a = x.split(':');
          return { cat: a[0] || 'gels', vid: a[1] || '' };
        }).slice(0, 3);
        if (parsedSol.length) { solidsState = parsedSol; renderSolids(); }
      }
      selectByValue('rk-drink', p.get('did'));
      selectByValue('rk-caps', p.get('cid'));
      if (p.has('mx')) { var m = document.querySelector('input[name="rk-mix"][value="' + p.get('mx') + '"]'); if (m) m.checked = true; }
      if (p.has('ex')) {
        legExtra = {};
        p.get('ex').split(',').forEach(function (chunk) {
          var a = chunk.split(':');
          var idx = parseInt(a[0], 10);
          if (isNaN(idx) || !a[1]) return;
          if (!legExtra[idx]) legExtra[idx] = [];
          legExtra[idx].push({ vid: a[1], qty: Math.max(1, parseInt(a[2], 10) || 1) });
        });
      }
      if (p.has('legs')) {
        var parsed = p.get('legs').split(';').map(function (s2) {
          var a = s2.split(',');
          return { name: decodeURIComponent(a[0] || ''), km: a[1] || '', hm: a[2] || '', dropbag: a[3] === '1' };
        });
        if (parsed.length >= 2) { legsState = parsed; return true; }
      }
      return false;
    } catch (e) { return false; }
  }
  function selectByValue(id, val) {
    if (!val) return;
    var sel = $(id);
    if (!sel) return;
    for (var i = 0; i < sel.options.length; i++) {
      if (sel.options[i].value === val) { sel.selectedIndex = i; return; }
    }
  }

  function copyLink() {
    updateURL();
    var url = window.location.href, btn = $('rk-copy');
    function done() {
      if (!btn) return;
      btn.textContent = 'Link kopieret';
      btn.classList.add('is-done');
      setTimeout(function () {
        if (!btn.isConnected) return;
        btn.textContent = 'Kopiér link til planen';
        btn.classList.remove('is-done');
      }, 1800);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done, function () {});
    } else {
      var t = document.createElement('textarea');
      t.value = url; document.body.appendChild(t); t.select();
      try { document.execCommand('copy'); done(); } catch (e) {}
      document.body.removeChild(t);
    }
  }

  function renderSweatField() {
    var el = $('rk-sweat-box');
    if (!el) return;
    var measured = window.SportEnergyProfile ? window.SportEnergyProfile.getSweatRate() : null;
    if (measured) {
      el.innerHTML = '<div class="sv-banner"><span>Svedrate: <strong>' + measured
        + ' ml i timen</strong> — dit målte tal fra svedtesten bruges automatisk.</span>'
        + '<a class="sv-delete" href="/pages/svedtest">Ny måling</a></div>';
    } else {
      el.innerHTML = '<span class="sv-label">Svedrate</span><div class="rk-radio-row">'
        + '<label class="seg-opt"><input type="radio" name="rk-sweat" value="600"><span>Lav (≈600 ml/t)</span></label>'
        + '<label class="seg-opt"><input type="radio" name="rk-sweat" value="900" checked><span>Normal (≈900 ml/t)</span></label>'
        + '<label class="seg-opt"><input type="radio" name="rk-sweat" value="1300"><span>Høj (≈1300 ml/t)</span></label></div>'
        + '<p class="sv-foot">Vil du have dit eget tal? <a href="/pages/svedtest">Tag svedtesten</a> — én vejning før og efter.</p>';
    }
  }

  // FASE 4.7.0: Natrium-profilen fra screeningen forudvælges —
  // atleten kan overstyre pr. plan uden at ændre profilen.
  function applySodiumProfile() {
    var na = window.SportEnergyProfile && window.SportEnergyProfile.getSodium
      ? window.SportEnergyProfile.getSodium() : null;
    if (!na) return;
    var radio = document.querySelector('input[name="rk-salt"][value="' + (na === 'salt' ? '1000' : na === 'lav' ? '450' : '650') + '"]');
    if (radio) radio.checked = true;
    var box = $('rk-salt-box');
    if (box && !$('rk-salt-note')) {
      var note = document.createElement('p');
      note.className = 'sv-foot';
      note.id = 'rk-salt-note';
      note.textContent = 'Forudvalgt fra din screening på svedtest-siden.';
      box.appendChild(note);
    }
  }

  window.RK = { template: applyTemplate, demo: demo, sport: setSport, raceType: setRaceType, extraAdd: extraAdd, extraQty: extraQty, extraRemove: extraRemove, raceVal: setRaceVal, calc: calc, addLeg: addLeg, removeLeg: removeLeg, setLeg: setLeg, copyLink: copyLink, renderLegs: renderLegs, addToCart: addToCart, printCards: printCards, fold: fold, solidCat: solidCat, solidVid: solidVid, solidAdd: solidAdd, solidRemove: solidRemove, setMode: setMode, legSwap: legSwap };

  var buildBtn = $('rk-build');
  if (buildBtn) buildBtn.addEventListener('click', calc);
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('.rk-cta') : null;
    if (t && t !== buildBtn) calc();
  });
  legsState = defaultLegs();
  renderRaceFields();
  renderSolids();
  autoCarbs();
  fillTemplates();
  // Flaskens indhold: energipulver, hydreringspulver og tabletter i grupper.
  fillGroupedDrink();
  // 'Kapsler' indeholder ikke substringen 'kapsel' (ka-ps-LER) — deraf den
  // tomme dropdown ved Phillips test. Matcher nu kategorien præcist og
  // kræver natrium, så vitamin-kapsler ikke sniger sig ind.
  fillSelect('rk-caps', productList(function (p) { return /^kapsler$/i.test(p.v.trim()) && p.na >= 50; }, 0), 'Ingen kapsler');
  renderSweatField();
  applySodiumProfile(); // før loadURL — et delt links na-param vinder for sessionen
  var hadURL = loadURL();
  if (!hadURL) renderEmptyState();
  if (!legsState || legsState.length < 2) legsState = defaultLegs();
  renderLegs();
  if (hadURL) calc();
})();